import _result from 'lodash/result'
import _get from 'lodash/get'
import _has from 'lodash/has'
import _map from 'lodash/map'
import _orderBy from 'lodash/orderBy'
import _filter from 'lodash/filter'
import _uniq from 'lodash/uniq'
import _startCase from 'lodash/startCase'
import _isEmpty from 'lodash/isEmpty'
import _some from 'lodash/some'
import _groupBy from 'lodash/groupBy'
import React from 'react'
import { changeSeat, fetchSeatsIoData } from '../../_common/core/http_services/seatsio'

import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import moment from 'moment-timezone'
import Modal from 'react-modal'
import PerfectScrollbar from 'react-perfect-scrollbar'

import modalStyle from '../../_common/core/modalStyle'
import Card from '../_library/Card'
import Field from '../_library/Field'
import Button from '../_library/Button'
import Filters from '../_library/Filters'
import LoadingBar from '../_library/LoadingBar'
import { SaveTemplate, SelectFilterTemplate } from '../_library/FilterTemplate'

import EventOrderTicketForm from './order/TicketForm'
import TicketsTypeBulkUpdate from './order/TicketsTypeBulkUpdate'

import Scroll, { scroller } from 'react-scroll'

import OrderDateFilter from './order/OrderDateFilter'

import { toPascalCase } from '../../_common/core/utils'
import {
  createFixedFloatNormalizer,
  currencyNormalizerCreator,
  formatDate,
} from '../../_common/core/validation'
import { DISPLAY_FORMAT } from '../constants/timeFormats'
import {
  CANCEL_ORDER,
  FETCH_EVENT_ORDERS,
  MARK_ORDER_AS_PAID,
  REFRESH_ORDERS_DATA,
  REFUND_ORDER,
  REJECT_PENDING_ORDER,
  REQUEST_REFUND_ORDER_AUTH_CODE,
  RESEND_CODE,
  RESEND_ORDER,
  REVOKE_CODE,
  TICKETS_TYPE_BULK_UPDATE,
  TOGGLE_ORDER_RESALE,
  UPDATE_ORDER_TICKET,
} from '../../_common/redux/orders/actions'
import { FETCH_EVENT_TICKETS } from '../../_common/redux/tickets/actions'
import { FETCH_EVENT_ADDONS } from '../../_common/redux/addons/actions'
import { ROLES } from '../constants/roles'
import { ENV } from '../constants/env'
import { constructInstagramUrl } from '../utils/urlUtils'

import {
  DATATABLE,
  DOWNLOAD_CSV,
  IS_FOUND,
  JSONDatatable,
  PAGINATIONBAR,
  SEARCHBAR,
  TYPE_FROM_ARRAY,
} from '../_library/JSONDatatable'
import EmptyBar from '../_library/EmptyBar'

import {
  get_all_addons,
  get_event,
  get_event_orders_state,
  get_event_role,
  get_event_tickets,
} from '../../_common/core/selectors'
import { NotesRows } from './_library/NotesRows'
import { SocialMediaRow } from './_library/SocialMediaRow'
import { getTitle } from '../utils/getTitle'

import SortableTable from '../_library/SortableTable'
import { getTableColumns } from '../utils/sortableTableUtils'
import IssueAddOnForm from './order/IssueAddOnForm'
import { issueGuestAddOn } from '../../_common/core/http_services'
import { showAxiosError, showSuccessMessage } from '../utils/messenger'
import { getPermissions } from '../_theme/utils/permissions'
import { OverlayTrigger } from '../_library/OverlayTrigger'
import { OrderPosButton } from './order/OrderPosButton'
import { getPaymentMethodTypeIcon } from '../utils/paymentMethods'
import InlineLoader from '../_library/InlineLoader'
import { SeatsioEventManager } from '@seatsio/seatsio-react'
import TicketTypeBulkPrint from './order/TicketTypeBulkPrint'
import Tooltip from 'react-bootstrap/lib/Tooltip'
import { SeatsIoSeasonEventPicker } from './form/EventForm/SeatsIo/SeatsIoSeasonEventPicker'

function elementExists(el) {
  if (typeof el !== 'undefined' && el != null) {
    return true
  }
  return false
}

function b64toBlob(b64Data, contentType = '', sliceSize = 512) {
  const byteCharacters = atob(b64Data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)

    byteArrays.push(byteArray)
  }

  const blob = new Blob(byteArrays, {
    type: contentType,
  })

  return blob
}

function createURL(b64) {
  if (b64 === '') {
    return ''
  }
  const blob = b64toBlob(b64, 'application/pdf')
  const srcUrl = window.URL.createObjectURL(blob)
  return srcUrl
}

function print(b64) {
  // TODO add a way to regenerate/get tickets again?
  const srcUrl = createURL(b64)
  if (srcUrl === '') {
    showAxiosError({}, 'No tickets to print')
    return
  }
  let iframe = document.getElementById('tickets-pdf')
  const iframeExists = elementExists(iframe)
  if (!iframeExists) {
    iframe = document.createElement('iframe')
    iframe.name = 'tickets-pdf'
    iframe.id = 'tickets-pdf'
    iframe.style.visibility = 'hidden'
  }
  iframe.src = srcUrl
  iframe.onload = () => {
    const pdfFrame = window.frames['tickets-pdf']
    pdfFrame.focus()
    pdfFrame.print()
  }
  if (!iframeExists) {
    document.body.appendChild(iframe)
  }
}

const ORDER_STATUS_ALL = 0
const ORDER_STATUS_PAID = 1
const ORDER_STATUS_REFUNDED = 2
const ORDER_STATUS_PENDING = 3
const PENDING_PAYMENT_PLAN = 4
const ORDER_STATUS_SOLD = 5
const ORDER_STATUS_FOR_SALE = 6
const ORDER_STATUS_SALE_IN_PROGRESS = 7
const PENDING_OXXO_ORDER = 8
const NEED_ID_VERIFICATION = 9
const ORDER_STATUS_CANCELLED = 13

const TABLE_E2E_TEST_ID = 'event_orders'

const getPaymentMethodIcon = (paymentMethod = 'google_pay') => {
  if (!paymentMethod) return null

  const nameArr = paymentMethod.includes('_') ? paymentMethod.split('_') : paymentMethod.split(' ')
  const nameStr = nameArr.join('')

  const nameOption1 = _startCase(nameStr.toLowerCase())
  const nameOption2 = _startCase(nameArr[0].toLowerCase())

  if (paymentMethod === 'cash') {
    return <img alt="no-data" src={asset('/resources/images/system_icons/cash-money.svg')} />
  }

  if (paymentMethod === 'stripe_pos') {
    return <img alt="no-data" src={asset('/resources/images/stripe-pos.png')} style={{ width: 'inherit' }} />
  }

  return getPaymentMethodTypeIcon([nameStr, nameOption1, nameOption2])
}

export const getTicketRows = ({
  rowIndex,
  tickets,
  status,
  paymentPlanDetails,
  addOns,
  ticketDataCapture,
  orderId,
  discountCode,
  includeTablesData,
  guestCount,
  currency,
  debt,
  total,
  openTicketEditModal,
  openSeatEditModal,
  setTicketTypesBulkUpdateModalState,
  event,
  eventId,
  timeSlotsEnabled,
  eventsInOrder,
  customerId,
  allAddOns,
  setIssueAddOnModalState,
  user,
  eventRole,
  showIssueGuestAddOnButton,
  promotion = null,
  showSeatMapName = false,
}) => {
  const permissions = getPermissions(eventRole)
  const isAdminOrOwner = permissions.isAdminOrOwner()
  const isTtfTeam = ROLES.is_tf_support_admin_or_client_admin(user.tfRole)
  const isTfDeveloper = user?.tfRole === ROLES.TF_DEVELOPER

  const payment_plans_rows =
    status === 'Payment plan'
      ? (paymentPlanDetails || []).map((item, i) => {
        let row_color = 'ticket-yellow'
        if (item.status === 'succeeded' || item.status === 'paid') {
          row_color = 'ticket-green'
        }
        if (item.status === 'failed') {
          row_color = 'ticket-red'
        }
        return (
          <div key={String(i)} className={`row-content row-ticket row ${row_color}`}>
            <div className="col-xs-2">
              <div className="content">
                <div className="value">{item.type}</div>
              </div>
            </div>
            <div className="col-xs-2">
              <div className="content">
                <div className="value">{`${event.currency.symbol}${item.amount}`}</div>
              </div>
            </div>
            <div className="col-xs-3">
              <div className="content">
                <div>{formatDate(item.charge_date || item.scheduled_date, DISPLAY_FORMAT)}</div>
              </div>
            </div>
            <div className="col-xs-2">
              <div className="content">
                <div className="value">{item.status}</div>
              </div>
            </div>
          </div>
        )
      })
      : null

  const addons_rows = _map(
    _groupBy(addOns, item => [item.groupName || item.name, item.status]),
    (groupedAddOns, aid) => {
      const addonQuantity = groupedAddOns.length

      const addonName =
        groupedAddOns[0]?.groupName || groupedAddOns[0]?.name || ''

      const addonStatus =
        groupedAddOns[0]?.status || ''

      return (
        <div key={aid} className="row-content row">
          <div className="col-xs-3">
            <div className="content">
              <div className="value">{addonName}</div>
            </div>
          </div>

          <div className="col-xs-3">
            <div className="content">
              <div className="value">{addonQuantity}</div>
            </div>
          </div>

          <div className="col-xs-3">
            <div className="content">
              <div className="value">{_startCase(addonStatus)}</div>
            </div>
          </div>

          <div className="col-xs-3">
            <div className="content">
              <div className="value">
                {_map(groupedAddOns, addon =>
                  addon.resoldFromOrderId
                    ? `Purchased via resale of add-on named ${addon.resellerName || ''} ${addon.resellerSurname || ''
                    } in Order ${addon.resoldFromOrderId}`
                    : '',
                ).filter(Boolean)}
              </div>
            </div>
          </div>
        </div>
      )
    },
  )
  const isSeatMapAllowed = event?.flagSeatMapAllowed && event?.seatProvider === 'seats_io'

  const isSeatNameExist = _some(tickets, ticket => ticket.seatName)
  const ticket_rows = _map(tickets, (ticket, tid) => {
    const isValidTicket = ticket.status === 'valid' || ticket.status === 'checked in'
    const showIssueAddOnButton =
      showIssueGuestAddOnButton &&
      !event.flagGuestAddOnDisabled &&
      allAddOns.length > 0 &&
      isValidTicket &&
      (isAdminOrOwner || isTtfTeam || permissions.PERMISSION_CURATOR)
    const isEmptyAddOnsStock = !_some(allAddOns, item => item.stock !== 0)

    let row_color = 'ticket-red'
    if (ticket.status === 'valid') row_color = 'ticket-green'
    if (ticket.status === 'checked in') row_color = 'ticket-yellow'
    const ticketDataCapture_rows = []
    _map(ticketDataCapture, (tdcRow, tdcid) => {
      if (tdcRow.ticketHash === ticket.ticketHash) {
        ticketDataCapture_rows.push(
          <div key={tdcid} className={'row-content row-ticket row ticket-gray'}>
            <div className="col-xs-6">
              <div className="content">
                <div className="value">{tdcRow.name}</div>
              </div>
            </div>
            <div className="col-xs-6">
              <div className="content">
                <div className="value">{tdcRow.value}</div>
              </div>
            </div>
          </div>,
        )
      }
    })
    return (
      <div key={tid}>
        <div className={'row-content row-ticket row ' + row_color}>
          <div
            className="col-xs-2"
            data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${rowIndex - 1}-${tid}-ticketHash`}
          >
            <div className="content">
              <div className="value">
                <a
                  href={`${ENV.API_BASE}/download-ticket/${ticket.id || ticket.ticketId}/${ticket.ticketHash
                    }/`}
                >
                  <i className="fa fa-download" aria-hidden="true" />
                </a>
                &nbsp;&nbsp;
                <i
                  className="fa fa-edit"
                  aria-hidden="true"
                  onClick={() => openTicketEditModal(ticket, orderId, ticket.eventId, customerId)}
                />
                &nbsp;&nbsp;
                {ticket?.ticketHash?.toUpperCase()}
              </div>
            </div>
          </div>
          <div className="col-xs-2" data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${rowIndex - 1}-${tid}-fullName`}>
            <div className="content">
              <div className="value">
                {ticket.firstName} {ticket.lastName}
              </div>
            </div>
          </div>
          <div
            className="col-xs-2"
            data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${rowIndex - 1}-${tid}-ticketType`}
          >
            <div className="content">
              <div className="value">{ticket.ticketType}</div>
            </div>
          </div>
          {(isSeatMapAllowed || isSeatNameExist) && (
            <>
              {showSeatMapName && (
                <div
                  className="col-xs-2"
                  data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${rowIndex - 1}-${tid}-seatMapName`}
                >
                  <div className="content">
                    <div className="value">{ticket.seatMapName}</div>
                  </div>
                </div>
              )}
              <div
                className="col-xs-2"
                data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${rowIndex - 1}-${tid}-seatName`}
              >
                <div className="content">
                  <div className="value">
                    {isSeatMapAllowed &&
                      !ticket.seatName &&
                      (isAdminOrOwner || isTtfTeam || isTfDeveloper) && (
                        <button
                          className="btn btn-transparent"
                          style={{ textAlign: 'center', marginLeft: '0' }}
                          onClick={() => openSeatEditModal(ticket, orderId, ticket.eventId, customerId)}
                        >
                          Assign Seat
                        </button>
                      )}
                    {ticket.seatName}
                    &nbsp;&nbsp;
                    {isSeatMapAllowed &&
                      !!ticket.seatName &&
                      (isAdminOrOwner || isTtfTeam || isTfDeveloper) && (
                        <i
                          className="fa fa-edit"
                          aria-hidden="true"
                          onClick={() => openSeatEditModal(ticket, orderId, ticket.eventId, customerId)}
                        />
                      )}
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="col-xs-2" data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${rowIndex - 1}-${tid}-status`}>
            <div className="content">
              <div className="value">{ticket.status}</div>
            </div>
          </div>
          <div className="col-xs-2" data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${rowIndex - 1}-${tid}-tags`}>
            <div className="content">
              <div className="value" id={'ticket-column-tags-' + ticket.ticketHash} key={ticket.ticketHash}>
                {getTicketTagsColumn(ticket.tags)}
              </div>
            </div>
          </div>
          <div
            className="col-xs-2"
            data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${rowIndex - 1}-${tid}-extraInfo`}
          >
            <div className="content">
              <div className="value">{ticket.extraInfo}</div>
            </div>
          </div>
          {showIssueAddOnButton && (
            <div
              className="col-xs-2"
              data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${rowIndex - 1}-${tid}-extraInfo`}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                float: 'right',
              }}
            >
              <div className="content">
                <div className="value">
                  <OverlayTrigger
                    id="issue-add-on-tooltip"
                    tooltip="There are no Add-Ons left in the stock"
                    placement="top"
                    className={isEmptyAddOnsStock ? 'inline-block cursor-not-allowed' : 'inline-block'}
                    hideTooltip={!isEmptyAddOnsStock}
                  >
                    <div>
                      <button
                        type="button"
                        className={`btn btn-primary btn-shadow button-event-order ${isEmptyAddOnsStock ? 'btn-disabled' : ''
                          }`}
                        onClick={() => {
                          setIssueAddOnModalState(true, ticket.ticketHash)
                        }}
                        disabled={isEmptyAddOnsStock}
                        style={{ height: 40 }}
                      >
                        Issue Guest <br /> Add-on
                      </button>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          )}
        </div>
        {ticketDataCapture_rows.length > 0 && (
          <div className="row-ticketDataCapture">
            <div className="row-title row">
              <span>
                <i className="fa fa-table" aria-hidden="true" /> Data Capture
              </span>
            </div>
            <div className="row-content-expanded">
              <div className="row-content row-ticket row">
                <div className="col-xs-6">
                  <div className="content">
                    <div className="field">Field</div>
                  </div>
                </div>
                <div className="col-xs-6">
                  <div className="content">
                    <div className="field">Value</div>
                  </div>
                </div>
              </div>
              {ticketDataCapture_rows}
            </div>
          </div>
        )}
      </div>
    )
  })

  return (
    <div className="ticket-row-box">
      <div className="row-content row-ticket row">
        <div className="row-title row">
          <div className="col-xs-12 withDecorator ticket-type-bulk-update">
            <span>Tickets</span>
            {((!!ticket_rows.length && eventsInOrder === undefined) ||
              (eventsInOrder !== undefined && eventsInOrder === 1 && !!ticket_rows.length)) && (
                <button
                  type="button"
                  className="btn btn-primary btn-shadow pull-right button-event-order"
                  onClick={() => {
                    setTicketTypesBulkUpdateModalState(true, orderId, eventId, timeSlotsEnabled, customerId)()
                  }}
                >
                  {event?.flagTimeSlotsEnabled || timeSlotsEnabled ? 'Change Time Slot' : 'Change Ticket Type'}
                </button>
              )}
          </div>
          <div className="div-spacing-20" />
        </div>
        <div className="col-xs-2">
          <div className="content">
            <div className="field">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ticket ID
            </div>
          </div>
        </div>
        <div className="col-xs-2">
          <div className="content">
            <div className="field">Ticket Holder</div>
          </div>
        </div>
        <div className="col-xs-2">
          <div className="content">
            <div className="field">Ticket Type</div>
          </div>
        </div>
        {(isSeatMapAllowed || isSeatNameExist) && (
          <>
            {showSeatMapName && (
              <div className="col-xs-2">
                <div className="content">
                  <div className="field">Seat Map</div>
                </div>
              </div>
            )}
            <div className="col-xs-2">
              <div className="content">
                <div className="field">Seat</div>
              </div>
            </div>
          </>
        )}
        <div className="col-xs-2">
          <div className="content">
            <div className="field">Status</div>
          </div>
        </div>
        <div className="col-xs-2">
          <div className="content">
            <div className="field">Tags</div>
          </div>
        </div>
        <div className="col-xs-1">
          <div className="content">
            <div className="field">Notes</div>
          </div>
        </div>
        <div className="col-xs-1">
          <div className="content">
            <div className="field">Actions</div>
          </div>
        </div>
      </div>
      <div>{ticket_rows}</div>
      <div className="row-separator" />
      {status === 'Payment plan' && (
        <div>
          <div className="row-title row">
            <div className="col-xs-12 withDecorator ticket-type-bulk-update">
              <span>Payment Plan</span>
            </div>
          </div>
          <div className="div-spacing-20" />
          <div className="row-content row-ticket row">
            <div className="col-xs-2">
              <div className="content">
                <div className="field">Type</div>
              </div>
            </div>
            <div className="col-xs-2">
              <div className="content">
                <div className="field">Amount</div>
              </div>
            </div>
            <div className="col-xs-3">
              <div className="content">
                <div className="field">Date</div>
              </div>
            </div>
            <div className="col-xs-2">
              <div className="content">
                <div className="field">Status</div>
              </div>
            </div>
          </div>
          <div>{payment_plans_rows}</div>
          <div className="row-separator" />
        </div>
      )}
      {event?.flagStripeTerminalEnabled ? (
        <>
          <div className="row-title row">
            <div className={'col-xs-4 withDecorator'}>Print on BOCA Ticket Printer</div>
          </div>
          <div className="row-content row">
            <div className="div-spacing-20" />
            <div className={'col-xs-2'}>
              <OrderPosButton eventId={event.id} orderId={orderId} />
            </div>
          </div>
          <div className="row-separator" />
        </>
      ) : null}
      <div className="row-title row">
        <div className="col-xs-12 withDecorator">Add-ons / Upgrades</div>
      </div>
      <div className="div-spacing-20" />
      {addOns.length > 0 ? (
        <div className="row-content row">
          <div className="col-xs-3">
            <div className="content">
              <div className="field">Add-on / Upgrade</div>
            </div>
          </div>
          <div className="col-xs-3">
            <div className="content">
              <div className="field">Quantity</div>
            </div>
          </div>
          <div className="col-xs-3">
            <div className="content">
              <div className="field">Status</div>
            </div>
          </div>
          <div className="col-xs-3">
            <div className="content">
              <div className="field" />
            </div>
          </div>
        </div>
      ) : (
        <div className="row-content row">
          <div className="col-xs-12">
            <div className="content">
              <div className="value">Not purchased</div>
            </div>
          </div>
        </div>
      )}
      {addOns.length > 0 && <div>{addons_rows}</div>}
      {promotion && discountCode && (
        <>
          <div className="row-separator" />
          <div className="row-title row">
            <div className="col-xs-12 withDecorator">Promotion</div>
          </div>
          <div className="div-spacing-20" />
          <div className="row-content row">
            <div className="col-xs-3">
              <div className="content">
                <div className="field">Name</div>
              </div>
            </div>
            <div className="col-xs-3">
              <div className="content">
                <div className="field">Code</div>
              </div>
            </div>
          </div>
          <div className="row-content row">
            <div className="col-xs-3">
              <div className="content">
                <div className="value">{promotion}</div>
              </div>
            </div>
            <div className="col-xs-3">
              <div className="content">
                <div className="value">{discountCode}</div>
              </div>
            </div>
          </div>
        </>
      )}
      {discountCode && !promotion && (
        <>
          <div className="row-separator" />
          <div className="row-title row">
            <div className="col-xs-12 withDecorator">Promo Code</div>
          </div>
          <div className="div-spacing-20" />
          <div className="row-content row">
            <div className="col-xs-12">
              <div className="content">
                <div className="value">{discountCode}</div>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="row-separator" />
      {includeTablesData && parseInt(guestCount) > 0 && (
        <>
          <div className="row-title row">
            <div className="col-xs-12 withDecorator ticket-type-bulk-update">
              <span>Table data</span>
            </div>
          </div>
          <div className="div-spacing-20" />
          <div className="row-content row">
            <div className="col-xs-3">
              <div className="content">
                <div className="field">
                  <i className="fa fa-users" aria-hidden="true" /> Number of Guests
                </div>
                <div className="value email">{parseInt(guestCount)}</div>
              </div>
            </div>
            <div className="col-xs-3">
              <div className="content">
                <div className="field">Current deposit</div>
                <div className="value">
                  {currency}
                  {total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </div>
              </div>
            </div>
            <div className="col-xs-3">
              <div className="content">
                <div className="field">Pending to Pay</div>
                <div className="value">
                  {currency}
                  {debt.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </div>
              </div>
            </div>
          </div>
          <div className="row-separator" />
        </>
      )}
      <NotesRows orderID={orderId} />
    </div>
  )
}

export const getTicketTagsColumn = tags => (
  <div>
    {tags &&
      tags.map((tag, ii) => (
        <div key={ii} className="row-ticket-tag">
          {tag}
        </div>
      ))}
  </div>
)

export const orderDetailRow = ({
  t,
  event,
  index,
  includeTablesData,
  currency,
  total,
  debt,
  openTicketEditModal,
  openSeatEditModal,
  setTicketTypesBulkUpdateModalState,
  openCustomerNoteEditModal,
  deleteCustomerNote,
  isNotesLoading,
  isCustomerCRM,
  SortableTable,
  addOns,
  setIssueAddOnModalState,
  user,
  eventRole,
  showIssueGuestAddOnButton,
}) => {
  let content_row = null
  let ticket_rows = null
  let data_capture_rows = null

  if (!isCustomerCRM) {
    ticket_rows = getTicketRows({
      rowIndex: index,
      tickets: t.tickets,
      status: t.status,
      paymentPlanDetails: t.paymentPlanDetails,
      addOns: t.addOns,
      ticketDataCapture: t.ticketDataCapture,
      orderId: t.order.id,
      discountCode: t.order.discountCode,
      includeTablesData,
      guestCount: t.order.guestCount,
      currency,
      debt,
      total,
      openTicketEditModal,
      openSeatEditModal,
      setTicketTypesBulkUpdateModalState,
      event,
      allAddOns: addOns,
      setIssueAddOnModalState,
      user,
      eventRole,
      showIssueGuestAddOnButton,
      promotion: t.order?.promotion ?? null,
      showSeatMapName: !!t.order?.seatMapName,
    })
  }

  // Separate text and image data capture fields
  const textDataCapture = (t.dataCapture || []).filter(dcRow => dcRow.type !== 'image')
  const imageDataCapture = (t.dataCapture || []).filter(dcRow => dcRow.type === 'image')

  // Render text-based data capture fields for the table
  data_capture_rows = _map(textDataCapture, (dcRow, dcid) => (
    <div key={dcid} className={'row-content row-ticket row ticket-green'}>
      <div className="col-xs-6">
        <div className="content">
          <div className="value">{dcRow.name}</div>
        </div>
      </div>
      <div className="col-xs-6">
        <div className="content">
          <div className="value">{dcRow.value}</div>
        </div>
      </div>
    </div>
  ))

  // Render image data capture fields separately
  const image_data_capture_rows = _map(imageDataCapture, (dcRow, dcid) => (
    <div key={dcid} className="row-content row" style={{ marginBottom: '15px' }}>
      <div className="col-xs-12">
        <div className="content">
          <div className="field" style={{ marginBottom: '8px', fontWeight: 'bold' }}>
            {dcRow.name}
          </div>
          <div className="value">
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '15px' }}>
              <img
                src={dcRow.value}
                alt={dcRow.name}
                style={{
                  width: '100px',
                  height: '100px',
                  objectFit: 'cover',
                  borderRadius: '4px',
                  border: '1px solid #ddd',
                  cursor: 'pointer',
                }}
                onClick={() => openImageModal(dcRow.value)}
                onError={e => {
                  e.target.style.display = 'none'
                }}
              />
              <button
                type="button"
                className="btn btn-link"
                onClick={() => openImageModal(dcRow.value)}
                style={{ padding: 0, textDecoration: 'underline' }}
              >
                View Image
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  ))

  content_row = (
    <div className="row-detail">
      <div className="row-title row">
        <div className={`${isCustomerCRM ? 'col-xs-4' : 'col-xs-6'} withDecorator`}>Contact Information</div>
        <div className={`${isCustomerCRM ? 'col-xs-4' : 'col-xs-6'} withDecorator`}>Location</div>
        {isCustomerCRM ? (
          <div className="col-xs-4 withDecorator">
            Notes&nbsp;&nbsp;&nbsp;
            {isNotesLoading && <i className="fa fa-spin fa-spinner" aria-hidden="true" />}
          </div>
        ) : null}
      </div>
      <div className="div-spacing-20" />
      <div className="row-content row">
        <div className={isCustomerCRM ? 'col-xs-2' : 'col-xs-3'}>
          <div className="content">
            <div className="field">
              <i className="fa fa-envelope" aria-hidden="true" /> Email Address
            </div>
            <div className="value email">{t.order.billingEmail}</div>
          </div>
        </div>
        <div className={isCustomerCRM ? 'col-xs-2' : 'col-xs-3'}>
          <div className="content">
            <div className="field">
              <i className="fa fa-phone-square" aria-hidden="true" /> Phone Number
            </div>
            <div className="value">{t.order.billingPhone}</div>
          </div>
        </div>
        <div className={isCustomerCRM ? 'col-xs-2' : 'col-xs-3'}>
          <div className="content">
            <div className="field">
              <i className="fa fa-map-marker" aria-hidden="true" /> City
            </div>
            <div className="value">{t.order.billingCity}</div>
          </div>
        </div>
        <div className={isCustomerCRM ? 'col-xs-2' : 'col-xs-3'}>
          <div className="content">
            <div className="field">
              <i className="fa fa-globe" aria-hidden="true" /> Country
            </div>
            <div className="value">{t.order.billingCountry}</div>
          </div>
        </div>
      </div>
      <div className="row-content row" style={{ marginTop: '10px' }}>
        <div className={isCustomerCRM ? 'col-xs-2' : 'col-xs-6'}>
          <div className="content">
            <div className="field">
              <i className="fa fa-user" aria-hidden="true" /> Instagram
            </div>
            {t.order.instagramHandle && (
              <div className="value instagram">
                <a
                  style={{ textDecoration: 'underline' }}
                  href={constructInstagramUrl(t.order.instagramHandle)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t.order.instagramHandle.startsWith('http') ? 'Instagram Profile' : t.order.instagramHandle}
                </a>
              </div>
            )}
          </div>
        </div>
        {isCustomerCRM ? (
          <div className="col-xs-4">
            {t.notes ? (
              <div className={'row-content row-notes row note-bg'}>
                <div className="col-xs-12">
                  <div className="content">
                    <div className="value" style={{ display: 'flex' }}>
                      <i
                        className="fa fa-edit"
                        aria-hidden="true"
                        onClick={() => {
                          openCustomerNoteEditModal(t.id, t.notes)
                        }}
                      />
                      &nbsp;&nbsp;
                      <i
                        className="fa fa-trash"
                        aria-hidden="true"
                        onClick={() => {
                          deleteCustomerNote(t.id)
                        }}
                      />
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <div>{t.notes}</div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="content">
                <div className="value">
                  <div
                    aria-hidden={true}
                    className="addNote"
                    onClick={() => {
                      openCustomerNoteEditModal(t.id, t.notes)
                    }}
                    style={{ color: 'rgb(182, 197, 207)' }}
                  >
                    <i className="fa fa-plus" aria-hidden="true" />
                    &nbsp;&nbsp;Add Note
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : null}
      </div>
      {isCustomerCRM ? <SocialMediaRow customerId={t.id} /> : null}
      {(t.order.referrerId || t.order.promoterFirstName) && (
        <>
          <br />
          <div className="row-title row">
            <div className="col-xs-6 withDecorator">{t.order.referrerId ? 'Referred By' : 'Sold By'}</div>
          </div>
          <div className="div-spacing-20" />
          <div className="row-content row">
            {(t.order.referrerFirstName || t.order.promoterFirstName) && (
              <div className="col-xs-3">
                <div className="content">
                  <div className="value">
                    {t.order.referrerId
                      ? `${t.order.referrerFirstName} ${t.order.referrerLastName}`
                      : `${t.order.promoterFirstName} ${t.order.promoterLastName}`}
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
      {t.order.resoldOrderId && (
        <>
          <div className="div-spacing-20" />
          <div className="row-title row">
            <div className="col-xs-6 withDecorator">Resale Information</div>
          </div>
          <div className="div-spacing-10" />
          <div className="row-content row">
            <div className="col-xs-12">
              <div className="content">
                <div className="value">
                  {`Purchased via resale of ticket named ${t.order.resellerName || ''} ${t.order.resellerSurname || ''
                    } ${t.order.resoldType === 'order' ? '' : `(Ticket ID ${t.order.resoldItemId})`} in Order ${t.order.resoldOrderId
                    }`}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="row-separator" />
      {t.dataCapture && textDataCapture.length > 0 && (
        <div className="row-title row">
          <div className="col-xs-6 withDecorator">Data Capture</div>
        </div>
      )}
      {t.dataCapture && textDataCapture.length > 0 && <div className="div-spacing-20" />}
      {t.dataCapture && textDataCapture.length > 0 && (
        <div className="row-content row-ticket row">
          <div className="col-xs-6">
            <div className="content">
              <div className="field">Question</div>
            </div>
          </div>
          <div className="col-xs-6">
            <div className="content">
              <div className="field">Answer</div>
            </div>
          </div>
        </div>
      )}
      {t.dataCapture && textDataCapture.length > 0 && data_capture_rows}
      {t.dataCapture && textDataCapture.length > 0 && <div className="row-separator" />}

      {imageDataCapture.length > 0 && (
        <>
          <div className="row-title row">
            <div className="col-xs-12 withDecorator">Image Uploads</div>
          </div>
          <div className="div-spacing-20" />
          {image_data_capture_rows}
          <div className="row-separator" />
        </>
      )}

      {t.order.twitchChannel && (
        <div className="row-title row">
          <div className="col-xs-6 withDecorator">Twitch Channel Information</div>
        </div>
      )}
      {t.order.twitchChannel && <div className="div-spacing-20" />}
      {t.order.twitchChannel && (
        <div className="row-content row">
          <div className="col-xs-4">
            <div className="content">
              <div className="field">
                <i className="fa fa-twitch" aria-hidden="true" /> User ID
              </div>
              <div className="value">{t.order.twitchUserId}</div>
            </div>
          </div>
          <div className="col-xs-4">
            <div className="content">
              <div className="field">
                <i className="fa fa-twitch" aria-hidden="true" /> Broadcaster Name
              </div>
              <div className="value">{t.order.twitchChannel.display_name}</div>
            </div>
          </div>
          <div className="col-xs-4">
            <div className="content">
              <div className="field">
                <i className="fa fa-twitch" aria-hidden="true" /> Broadcaster Type
              </div>
              <div className="value">
                {t.order.twitchChannel.broadcaster_type
                  ? _startCase(t.order.twitchChannel.broadcaster_type)
                  : 'Regular'}
              </div>
            </div>
          </div>
        </div>
      )}
      {t.order.twitchChannel && <div className="row-separator" />}
      {isCustomerCRM ? (
        <div className="tickets-sortable-table-customers">
          <div className="row-title row">
            <div className={'col-xs-12 withDecorator'}>Orders</div>
          </div>
          {SortableTable}
        </div>
      ) : (
        <>
          <div>{ticket_rows}</div>
        </>
      )}
    </div>
  )

  return content_row
}

export const confirmRefundAuthCode = order => order?.authCodeStatus === 'active'

const canIssueRefundsOnEvent = event =>
  !event?.flagFundsRemitted && !event?.flagPaidInAdvance && !event?.flagWithholdPayout

/**
 * Check if an order has any tickets with tables
 * @param {Object} tickets - The tickets object
 * @returns {boolean} - True if any ticket has a table, false otherwise
 */
const hasTableInTickets = tickets => {
  // If no tickets, return false
  if (!tickets || !tickets.length) {
    return true
  }

  // Check if any ticket has a table
  return tickets.some(
    ticket =>
      // Check the isTable property where '1' means it's a table
      ticket.isTable === '1',
  )
}

const allTicketsValid = tickets => {
  // If no tickets, return false
  if (!tickets || !tickets.length) {
    return false
  }

  // Check if all tickets are valid
  return tickets.every(
    ticket =>
      // Check ticket status is/are valid
      ticket.status === 'valid',
  )
}

const canSeeRefundButton = (order, event, user, eventRole, tickets) => {
  const hasTotal = order?.total > 0
  const hasRefundsEnabled = event?.flagAllowDashboardRefunds
  const hasValidStatus = order?.status === 'Paid'
  const isTtfSupport = ROLES.is_tf_support(user.tfRole)
  const isOwner = eventRole === 'owner'
  const isNonRefundableBoxOfficeSale = order?.isNonRefundableBoxOfficeSale == '1'
  const isPaymentMethodAllowed = order?.allowDashboardRefund == '1'
  // for now, tables are not refundable via dashboard
  const hasTable = hasTableInTickets(tickets)
  const allValidTickets = allTicketsValid(tickets)

  //if user doesn't have the right roles, no order can be refunded
  if (!isTtfSupport && !isOwner) {
    return false
  }

  if (
    !hasValidStatus ||
    !hasTotal ||
    isNonRefundableBoxOfficeSale ||
    !hasRefundsEnabled ||
    !isPaymentMethodAllowed ||
    hasTable ||
    !allValidTickets
  ) {
    return false
  }

  return true
}

export const requestRefundAuthCode = order =>
  order?.authCodeStatus === '' || order?.authCodeStatus === 'expired' || order?.authCodeStatus === 'revoked'

const conditionalOverlay = (element, { text, id, placement = 'left' }, condition = false) => {
  if (condition) {
    return (
      <OverlayTrigger placement={placement} id={id} tooltip={text.props.children} hideTooltip={false}>
        {element}
      </OverlayTrigger>
    )
  }
  return element
}

@connect(
  state => {
    const event = get_event(state)
    const eventRole = get_event_role(state)
    const ordersState = get_event_orders_state(state)
    const tickets = get_event_tickets(state)
    const isTicketsTypeUpdating = _has(state.loading, 'TICKETS_TYPE_BULK_UPDATE')
    const resent = _get(state, 'resent')
    const cancelled = _get(state, 'cancelled')
    const addOns = get_all_addons(state)
    const { user } = state.auth

    return {
      event,
      eventRole,
      ordersState,
      tickets,
      isTicketsTypeUpdating,
      resent,
      cancelled,
      addOns: addOns[event.id] || [],
      user,
    }
  },
  {
    RESEND_ORDER,
    CANCEL_ORDER,
    UPDATE_ORDER_TICKET,
    FETCH_EVENT_TICKETS,
    TICKETS_TYPE_BULK_UPDATE,
    FETCH_EVENT_ORDERS,
    TOGGLE_ORDER_RESALE,
    MARK_ORDER_AS_PAID,
    REJECT_PENDING_ORDER,
    REFRESH_ORDERS_DATA,
    FETCH_EVENT_ADDONS,
    REFUND_ORDER,
    REQUEST_REFUND_ORDER_AUTH_CODE,
    RESEND_CODE,
    REVOKE_CODE,
  },
)
export default class EventOrders extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      order_status: ORDER_STATUS_ALL,
      csvData: null,
      csvFileName: '',
      filter_types: [],
      filter_addons: [],
      filter_discountcodes: [],
      filter_payment_types: [],
      filter_promotions: [],
      filter_compOrder: false,
      dateFilterInfo: { range: { start: '', end: '' } },
      filters: [],
      showResend: false,
      resendEmail: '',
      showCancel: false,
      cancelled: false,
      cancelling: false,
      cancelMessage: '',
      orderID: null,
      refundSuccessMessage: '',
      refundErrorMessage: '',
      refundCodeSuccessMessage: '',
      refundCodeErrorMessage: '',
      ticketEditModalShow: false,
      seatEditModalShow: false,
      isTicketTypesBulkUpdateModalOpen: false,
      isIssueAddOnModalOpen: false,
      ticketEdited: null,
      expandedID: null,
      filterUpdateVersion: 0,
      loading: {},
      showRefund: false,
      refundOrderHash: null,
      refundMessage: 'Do you want to refund this order?',
      refundHelperMessage: '',
      refunding: false,
      refunded: false,
      sendingCode: false,
      revokingCode: false,
      changeSeatData: {
        new_seat_id: null,
        ticketHash: null,
        release_old_seat: true,
      },
      seatsIoConfigData: null,
      isLoadingSeatsIoConfigData: false,
      isUpdatingSeats: false,
      selectedSeatsIoEvent: 'main',
    }
    this.noteUID = 1
    this.defaultTicketTypeIDs = []
    this.seatsIoRef = React.createRef(null)
  }

  componentDidMount() {
    const {
      event: { id, displayName },
      FETCH_EVENT_TICKETS,
      FETCH_EVENT_ORDERS,
      FETCH_EVENT_ADDONS,
      configs,
    } = this.props
    const configDocTitle = _get(configs, 'messages.documentTitle', '')
    document.title = getTitle(configDocTitle, [displayName])

    Messenger.options = {
      extraClasses: 'messenger-fixed messenger-on-top messenger-on-right',
      theme: 'future',
    }
    FETCH_EVENT_TICKETS(id, { filter: 'all' })
    FETCH_EVENT_ORDERS(id)
    FETCH_EVENT_ADDONS(id)
    this.triggerOrderIdSearchFromUrl()
  }

  handleOrderSearchChange = (value, ...args) => {
    const searchString = value && value.join ? value.join('') : ''
    if (searchString.length === 0) {
      // Always remove ALL query params from the URL
      const url = `${window.location.pathname}${window.location.hash}`
      window.history.replaceState({}, '', url)
      this.setState({
        search: [],
        order_status: ORDER_STATUS_ALL,
        filter_types: [],
        filter_addons: [],
        filter_discountcodes: [],
        filter_payment_types: [],
        filter_compOrder: false,
        dateFilterInfo: { range: { start: '', end: '' } },
        filters: [],
        expandedID: null,
        // Add any other state resets as needed
      })
      return
    }
    // Update search and add orderId to URL if it's a valid order ID search
    this.setState({ search: value }, () => {
      const params = new URLSearchParams(window.location.search)

      // If searching for what looks like an order ID, add it to URL
      if (searchString && !isNaN(searchString)) {
        params.set('orderId', searchString)
      } else {
        params.delete('orderId')
      }

      const newUrl = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}${window.location.hash}`
      window.history.replaceState({}, '', newUrl)
    })
  }

  triggerOrderIdSearchFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search)
      const orderId = params.get('orderId')
      if (orderId) {
        this.setState({ search: [orderId] })
      }

      // Parse filters from URL
      this.parseFiltersFromUrl(params)
    } catch (e) {
      console.error(e)
    }
  }

  componentDidUpdate() {
    const { event, ordersState } = this.props
    const { expandedID } = this.state

    if (ordersState.eventId === event.id && ordersState.orders.length > 0 && expandedID === null) {
      const params = new URLSearchParams(window.location.search)
      const paramOrderID = params.get('id')
      const isOrderExists = ordersState.orders.some(order => order?.order?.id === paramOrderID)

      if (isOrderExists) {
        this.setState({ expandedID: paramOrderID })
      }
    }
  }

  parseFiltersFromUrl(params) {
    try {
      // Parse individual filter parameters
      const urlFilters = []
      const filterCompOrder = params.get('filterCompOrder') === 'true'
      const orderStatus = params.get('orderStatus')

      // Parse JSON-encoded filters array
      const filtersParam = params.get('filters')
      if (filtersParam) {
        try {
          const parsedFilters = JSON.parse(decodeURIComponent(filtersParam))
          urlFilters.push(...parsedFilters)
        } catch (jsonError) {
          console.error('Invalid filters JSON in URL parameter:', jsonError)
          // Let's continue with other URL parameters
        }
      }

      // Parse date filter
      const dateStart = params.get('dateStart')
      const dateEnd = params.get('dateEnd')
      const dateFilterInfo = {
        range: {
          start: dateStart || '',
          end: dateEnd || '',
        },
      }

      // Update state with URL filters
      const stateUpdate = {}
      if (urlFilters.length > 0) {
        stateUpdate.filters = urlFilters
      }
      if (filterCompOrder) {
        stateUpdate.filter_compOrder = filterCompOrder
      }
      if (orderStatus && !isNaN(parseInt(orderStatus))) {
        stateUpdate.order_status = parseInt(orderStatus)
      }
      if (dateStart || dateEnd) {
        stateUpdate.dateFilterInfo = dateFilterInfo
      }

      if (Object.keys(stateUpdate).length > 0) {
        this.setState(stateUpdate)
      }
    } catch (e) {
      console.error('Error parsing filters from URL:', e)
    }
  }

  updateUrlWithFilters = (newState = {}) => {
    try {
      const currentState = { ...this.state, ...newState }
      const params = new URLSearchParams(window.location.search)

      // Preserve existing orderId if present
      const orderId = params.get('orderId')

      // Clear all filter-related params
      params.delete('filters')
      params.delete('filterCompOrder')
      params.delete('orderStatus')
      params.delete('dateStart')
      params.delete('dateEnd')

      // Add current filters to URL
      if (currentState.filters && currentState.filters.length > 0) {
        params.set('filters', JSON.stringify(currentState.filters))
      }

      if (currentState.filter_compOrder) {
        params.set('filterCompOrder', 'true')
      }

      if (currentState.order_status && currentState.order_status !== ORDER_STATUS_ALL) {
        params.set('orderStatus', currentState.order_status.toString())
      }

      if (currentState.dateFilterInfo?.range?.start) {
        params.set('dateStart', currentState.dateFilterInfo.range.start)
      }

      if (currentState.dateFilterInfo?.range?.end) {
        params.set('dateEnd', currentState.dateFilterInfo.range.end)
      }

      // Preserve orderId if it exists
      if (orderId) {
        params.set('orderId', orderId)
      }

      // Update URL without page reload
      const newUrl = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}${window.location.hash}`
      window.history.replaceState({}, '', newUrl)
    } catch (e) {
      console.error('Error updating URL with filters:', e)
    }
  }

  onClickTab = order_status => {
    this.setState({ order_status }, () => {
      this.updateUrlWithFilters({ order_status })
      
      // Re-request orders with appropriate status filter
      const { event, FETCH_EVENT_ORDERS } = this.props
      if (order_status === ORDER_STATUS_CANCELLED) {
        // For cancelled orders, request with status filter
        FETCH_EVENT_ORDERS(event.id, { status: ORDER_STATUS_CANCELLED })
      } else {
        // For other statuses, request all orders (client-side filtering will handle the rest)
        FETCH_EVENT_ORDERS(event.id)
      }
    })
  }

  onFilterCompOrder = (e, value) => {
    const filter_compOrder = _get(e, 'target.checked', e)
    this.setState({ filter_compOrder }, () => {
      this.updateUrlWithFilters({ filter_compOrder })
    })
  }

  openTicketEditModal = ticket => {
    this.setState({
      ticketEditModalShow: true,
      ticketEdited: ticket,
    })
  }

  closeTicketEditModal = () => {
    this.setState({
      ticketEditModalShow: false,
    })
  }

  loadSeatsIoConfig = async () => {
    const { event } = this.props
    try {
      const seatsIoConfigData = await fetchSeatsIoData(event.id)

      this.setState({
        seatsIoConfigData,
        isLoadingSeatsIoConfigData: false,
      })
    } catch (e) {
      showAxiosError(e)
      this.setState({
        seatEditModalShow: false,
        isLoadingSeatsIoConfigData: false,
      })
    }
  }

  openSeatEditModal = ticket => {
    this.loadSeatsIoConfig()
    this.setState({
      seatEditModalShow: true,
      ticketEdited: ticket,
      isLoadingSeatsIoConfigData: true,
      isUpdatingSeats: false,
    })
  }

  closeSeatEditModal = () => {
    this.setState({
      seatEditModalShow: false,
      changeSeatData: {
        new_seat_id: null,
        ticketHash: null,
        release_old_seat: true,
      },
      isUpdatingSeats: false,
      selectedSeatsIoEvent: 'main',
    })
  }
  handleSeatSave = async () => {
    const { event, FETCH_EVENT_ORDERS } = this.props
    const { changeSeatData } = this.state

    if (changeSeatData?.new_seat_id && changeSeatData?.ticketHash) {
      this.setState({
        isUpdatingSeats: true,
      })
      try {
        await changeSeat(event.id, changeSeatData.ticketHash, {
          new_seat_id: changeSeatData.new_seat_id,
          release_old_seat: changeSeatData.release_old_seat,
          new_seat_event_id: changeSeatData.new_seat_event_id ?? null,
        })
        FETCH_EVENT_ORDERS(event.id)
        this.ordersTable.manualRefresh()
        this.setState({
          seatEditModalShow: false,
          changeSeatData: {
            new_seat_id: null,
            ticketHash: null,
            release_old_seat: true,
          },
          isUpdatingSeats: false,
          selectedSeatsIoEvent: 'main',
        })
        Messenger().post({
          type: 'success',
          message: 'Seats updated successfully!',
          hideAfter: 5,
          showCloseButton: true,
        })
      } catch (error) {
        showAxiosError(error)
        this.setState({
          isUpdatingSeats: false,
        })
      }
    }
  }

  setTicketTypesBulkUpdateModalState =
    (isOpen, orderID = null) =>
      () => {
        this.setState({
          orderID,
          isTicketTypesBulkUpdateModalOpen: isOpen,
        })
      }

  setIssueAddOnModalState = (isOpen, ticketHash) => {
    this.setState({
      ticketHash,
      isIssueAddOnModalOpen: isOpen,
    })
  }

  handleTicketSave = form => {
    const { UPDATE_ORDER_TICKET, FETCH_EVENT_ORDERS, event } = this.props
    const { ticketEdited } = this.state
    return Promise.resolve(UPDATE_ORDER_TICKET(ticketEdited.ticketHash, form))
      .catch(err => {
        let errorMessage = err
        if (err.errors && err.errors.length > 0) {
          errorMessage = err.errors.map(e => e.details).join(' \n')
        }
        Messenger().post({
          type: 'error',
          message: errorMessage,
          hideAfter: 5,
          showCloseButton: true,
        })
        return Promise.reject(_result(err, 'toFieldErrors', err))
      })
      .then(v => {
        const tags = JSON.parse(v.data.$original.tickets[0].tags)
        const { changeStatus } = v.data.$original.tickets[0]
        const thash = ticketEdited.ticketHash
        const tagsElement = document.getElementById('ticket-column-tags-' + thash)
        const newTagsRender = this.getTicketTagsColumn(tags)
        this.setState({ ticketEditModalShow: false })
        ReactDOM.render(newTagsRender, tagsElement)

        const message =
          changeStatus === 'pending_user_confirmation'
            ? 'Successfully updated! \n Awaiting for customer confirmation.'
            : 'Successfully updated!'

        FETCH_EVENT_ORDERS(event.id)
        this.ordersTable.manualRefresh()

        Messenger().post({
          type: 'success',
          message,
          hideAfter: 5,
          showCloseButton: true,
        })
        return v
      })
  }

  handleTicketsTypeBulkUpdate = data => {
    const { TICKETS_TYPE_BULK_UPDATE, event } = this.props

    TICKETS_TYPE_BULK_UPDATE(event.id, this.state.orderID, data.ticketTypeId)
      .then(() => {
        Messenger().post({
          type: 'success',
          message: 'Successfully updated!',
          hideAfter: 5,
          showCloseButton: true,
        })
        this.defaultTicketTypeIDs[this.state.orderID] = data.ticketTypeId
        this.ordersTable.manualRefresh()
      })
      .catch(err => {
        Scroll.animateScroll.scrollToTop({ duration: 400 })
      })
      .finally(() => {
        this.setTicketTypesBulkUpdateModalState(false)()
      })
  }

  onDataChange = rows => {
    const { event } = this.props
    const fileName = 'tickets_' + event.id + '_' + moment().format('YYYYMMDDHHmmss') + '.csv'

    const data = []
    let newRow = {}
    let filter_types = []
    let filter_addons = []
    let filter_discountcodes = []
    let filter_payment_types = []
    let filter_promotions = []
    let filter_tags = []
    const filterReferrers = []
    // add body
    _map(rows, (t, index) => {
      if (t.tickets) {
        let refundedCount = 0
        _map(t.tickets, (ticket, tid) => {
          if (ticket.status === 'refunded') {
            refundedCount += 1
          }
          filter_types.push(ticket.ticketType)
          if (ticket.tags) {
            filter_tags.push(...ticket.tags)
          }
        })
        if (refundedCount === t.tickets.length && refundedCount !== 0) {
          t.order.status = 'Refunded'
        }
      }
      if (t.addOns) {
        _map(t.addOns, (addon, aid) => {
          filter_addons.push(addon.name)
        })
      }
      if (t.order.discountCode) {
        filter_discountcodes.push(t.order.discountCode)
      }

      if (t.order?.promotion ?? null) {
        filter_promotions.push(t.order.promotion)
      }

      if (t?.order?.paymentMethodDisplayType) {
        filter_payment_types.push(t.order.paymentMethodDisplayType)
      }
      if (t.tickets && t.order.status === 'Paid') {
        _map(t.tickets, (ticket, tid) => {
          newRow = {}
          newRow.qr_data = ''
          newRow.ticket_first_name = ticket.firstName
          newRow.ticket_last_name = ticket.lastName
          newRow.ticket_email = ticket.email
          newRow.buyer_email = t.order.billingEmail
          newRow.phone = t.order.billingPhone
          newRow.street_address = ''
          newRow.city = t.order.billingCity
          newRow.state = ''
          newRow.zip_postcode = ''
          newRow.country = t.order.billingCountry
          newRow.ticket_type = ticket.ticketType
          newRow.ticket_price = ''
          newRow.status = ticket.status
          newRow.order_id = t.order.id
          newRow.ticket_id = ticket.ticketHash
          newRow.ordered_by_first_name = t.order.billingFirstName
          newRow.ordered_by_last_name = t.order.billingLastName
          newRow.order_date = t.order.orderDate
          newRow.order_datetime = t.order.orderDateTime
          newRow.order_payment_method_type = t.order.orderPaymentMethodType
          newRow.checked_in_at = ''
          newRow.discount_code = t.order.discountCode
          newRow.twitch_display_name = ''
          newRow.twitch_partnered = ''
          newRow.upgrades = ''
          newRow.data_capture = ''
          if (ticket.status !== 'cancelled' && ticket.status !== 'refunded') data.push(newRow)
        })
      }
      if (t?.order?.referrerId) {
        if (!filterReferrers.find(item => item.value === t.order.referrerFirstName)) {
          filterReferrers.push({
            id: t.order.referrerId,
            name: `${t.order.referrerFirstName || ''} ${t.order.referrerLastName || ''}`,
            email: t.order.referrerEmail,
            value: t.order.referrerFirstName,
            label: t.order.referrerFirstName,
          })
        }
      }
    })

    filter_types = _orderBy(_uniq(filter_types))
    filter_addons = _orderBy(_uniq(filter_addons))
    filter_discountcodes = _orderBy(_uniq(filter_discountcodes))
    filter_promotions = _orderBy(_uniq(filter_promotions))
    filter_payment_types = _orderBy(_uniq(filter_payment_types))
    filter_tags = _orderBy(_uniq(filter_tags))
    this.setState({
      csvData: data,
      csvFileName: fileName,
      filter_types,
      filter_addons,
      filter_tags,
      filter_discountcodes,
      filter_payment_types,
      filterReferrers,
      filter_promotions,
    })
  }

  validateData = (data, index) => {
    // validate goes here
    if (!data.order) return null
    // set id
    data.id = data.order.id
    return data
  }

  getFilteredRows = (rows, search) => {
    const { eventRole, event } = this.props
    const { order_status, filter_compOrder, filters, dateFilterInfo } = this.state
    const keyword = search.join('').trim().toLowerCase()
    const { start, end } = dateFilterInfo.range
    let rows_filtered = rows
    if (
      ROLES.is_partial_support(eventRole) &&
      !filter_compOrder &&
      !filters.length &&
      !keyword &&
      !start &&
      !end
    ) {
      return []
    }

    // filter by order status
    // Skip client-side status filtering for ORDER_STATUS_CANCELLED since it's handled server-side
    if (order_status === ORDER_STATUS_CANCELLED) {
      // Server already filtered for cancelled orders, so use all returned rows
      rows_filtered = rows
    } else {
      switch (order_status) {
        case ORDER_STATUS_ALL:
          rows_filtered = rows
          break
        case ORDER_STATUS_PAID:
        case ORDER_STATUS_FOR_SALE:
        case ORDER_STATUS_SALE_IN_PROGRESS:
          rows_filtered = _filter(
            rows,
            item =>
              item.order.status === 'Paid' ||
              item.order.status === 'For sale' ||
              item.order.status === 'Sale in progress',
          )
          break
        case ORDER_STATUS_SOLD:
          rows_filtered = _filter(rows, { order: { status: 'Sold' } })
          break
        case ORDER_STATUS_PENDING:
          rows_filtered = _filter(rows, { order: { status: 'Pending' } })
          break
        case PENDING_PAYMENT_PLAN:
          rows_filtered = _filter(rows, { order: { status: 'Payment plan' } })
          break
        case ORDER_STATUS_REFUNDED:
          rows_filtered = _filter(rows, { order: { status: 'Refunded' } })
          break
        case PENDING_OXXO_ORDER:
          rows_filtered = _filter(rows, { order: { isOxxoPayment: '1', status: 'Pending For Oxxo' } })
          break
        case NEED_ID_VERIFICATION:
          rows_filtered = _filter(rows, { order: { status: 'Need Id Verification' } })
          break
        default:
          rows_filtered = rows
          break
      }
    }

    // filter by compOrder
    if (filter_compOrder) {
      rows_filtered = _filter(rows_filtered, item => item.order.compOrder)
    }

    // filter by filters
    if (filters.length > 0) {
      rows_filtered = _filter(rows_filtered, item => {
        let found = true
        _map(filters, (filter, index) => {
          let found1 = 0
          switch (filter.type) {
            case 'ticketType':
              _map(item.tickets, t => {
                found1 += t.ticketType === filter.value ? 1 : 0
              })
              break
            case 'addOn':
              _map(item.addOns, a => {
                found1 += a.name === filter.value ? 1 : 0
              })
              break
            case 'discountCode':
              const discount = item.order.discountCode
              if (discount) {
                found1 += discount.toLowerCase() === filter.value.toLowerCase()
              }
              break
            case 'paymentMethodDisplayType':
              const type = item?.order?.paymentMethodDisplayType
              if (type) {
                found1 += type.toLowerCase() === filter.value.toLowerCase()
              }
              break
            case 'promotion':
              const promotion = item.order?.promotion ?? null
              if (promotion) {
                found1 += promotion.toLowerCase() === filter.value.toLowerCase()
              }
            case 'referrers':
              if (
                (item.order.referrerFirstName || '').includes(filter.value) ||
                (item.order.referrerLastName || '').includes(filter.value)
              ) {
                found1 += 1
              }
              break
            case 'tags':
              _map(item.tickets, t => {
                found1 += t.tags?.includes(filter.value) ? 1 : 0
              })
              break
            default:
              break
          }
          if (filter.isNot) {
            found1 = found1 > 0 ? 0 : 1
          }
          if (filter.isAnd) {
            found = found && found1 > 0
          } else {
            found = found || found1 > 0
          }
        })
        return found
      })
    }

    // filter by search
    if (keyword !== '') {
      rows_filtered = _filter(rows_filtered, item => {
        let found = 0
        found += IS_FOUND(item.order.id, keyword)
        found += IS_FOUND(item.order.billingFirstName + ' ' + item.order.billingLastName, keyword)
        found += IS_FOUND(item.order.billingEmail, keyword)
        item.order.searchOrderNotes.forEach(item => {
          found += IS_FOUND(item, keyword)
        })

        if (item.order.resoldOrderId) {
          found += IS_FOUND(item.order.resoldOrderId, keyword)
        }

        if (item.order.resellerName) {
          found += IS_FOUND(item.order.resoldItemId, keyword)
          found += IS_FOUND(item.order.resellerName, keyword)
          found += IS_FOUND(item.order.resellerSurname, keyword)
        }

        if (item.order.twitchChannel) {
          found += IS_FOUND(item.order.twitchUserId, keyword)
          found += IS_FOUND(item.order.twitchChannel.display_name, keyword)
          found += IS_FOUND(
            item.order.twitchChannel.broadcaster_type ? item.order.twitchChannel.broadcaster_type : 'Regular',
            keyword,
          )
        }
        _map(item.tickets, t => {
          found += IS_FOUND(t.firstName + ' ' + t.lastName, keyword)
          found += IS_FOUND(t.email, keyword)
          found += IS_FOUND(t.ticketHash, keyword)
        })
        return found > 0
      })
    }

    if (start && end) {
      rows_filtered = rows_filtered.filter(order => {
        const tickets = order.tickets || []
        return tickets.some(el => {
          const allTickets = this.props.tickets || []
          const { timezone } = event
          const { ticketTypeID } = el
          const ticket = allTickets.find(el => el.id === ticketTypeID)
          if (ticket) {
            const startDate = +moment.tz(ticket.startDate, timezone).utc()
            return startDate >= start && startDate <= end
          }
          return false
        })
      })
    }

    return rows_filtered
  }

  getSortedRows = (rows_filtered, sort, includeTablesData) => {
    if (sort) {
      const dir = sort.asc ? 'asc' : 'desc'
      switch (sort.index) {
        case 1: // Order ID
          rows_filtered = _orderBy(rows_filtered, t => parseInt(t.id), dir)
          break
        case 2: // Date
          rows_filtered = _orderBy(rows_filtered, t => t.order.orderDateTime, dir)
          break
        case 3: // Status
          rows_filtered = _orderBy(rows_filtered, t => t.order.status, dir)
          break
        case 4: // Name
          rows_filtered = _orderBy(
            rows_filtered,
            t => (t.order.billingFirstName + ' ' + t.order.billingLastName).trim().toLowerCase(),
            dir,
          )
          break
        case 5: // Email
          rows_filtered = _orderBy(rows_filtered, t => t.order.billingEmail.trim().toLowerCase(), dir)
          break
        case 6: // No. of Tickets
          rows_filtered = _orderBy(
            rows_filtered,
            t =>
              (t?.tickets || []).filter(({ status }) => status !== 'cancelled' && status !== 'refunded')
                ?.length ??
              t?.gift?.ticketQuantity ??
              0,
            dir,
          )
          break
        case 7: // Payment Method Type
          rows_filtered = _orderBy(
            rows_filtered,
            t => (t?.order?.paymentMethodDisplayType || '').toLowerCase(),
            dir,
          )
          break
        case 8:
          if (!includeTablesData) {
            // Total Revenue
            rows_filtered = _orderBy(rows_filtered, t => parseFloat(t.order.totalCost ?? '0.00'), dir)
          } else {
            // Current deposit
            rows_filtered = _orderBy(
              rows_filtered,
              t => parseFloat(t?.order?.currentDeposit ?? t?.order?.totalCost ?? '0.00'),
              dir,
            )
          }
          break
        case 9:
          // Pending to Pay
          rows_filtered = _orderBy(rows_filtered, t => parseFloat(t?.order?.pendingToPay ?? 0), dir)
          break
        default:
          break
      }
    }
    return rows_filtered
  }

  getCSVData = (rows_filtered, includeTablesData) => {
    const data = []
    let newRow = []
    // add header
    newRow.push('Order ID')
    newRow.push('Date')
    newRow.push('Status')
    newRow.push('First Name')
    newRow.push('Last Name')
    newRow.push('Email')
    newRow.push('No. of Tickets')
    newRow.push('Payment Method Type')
    newRow.push('Currency')
    if (!includeTablesData) {
      newRow.push('Net Revenue')
    } else {
      newRow.push('Current Deposit')
      newRow.push('Pending to Pay')
    }
    newRow.push('Sold by Promoter')
    newRow.push('Promoter Email')
    newRow.push('Referred by Customer')
    newRow.push('Referrer Email')
    data.push(newRow)

    // add body
    _map(rows_filtered, (t, index) => {
      newRow = []
      newRow.push(t.id)
      newRow.push(moment(t.order.orderDateTime, 'YYYY-MM-DD HH:mm:ss').format('D MMM YYYY hh:mm a'))
      newRow.push(t.order.status)
      newRow.push(t.order.billingFirstName)
      newRow.push(t.order.billingLastName)
      newRow.push(t.order.billingEmail)
      newRow.push(
        (t?.tickets || []).filter(({ status }) => status !== 'cancelled' && status !== 'refunded')?.length ??
        t?.gift?.ticketQuantity ??
        0,
      )
      newRow.push(t?.order?.paymentMethodDisplayType || '')
      newRow.push(t?.order?.currency)

      if (!includeTablesData) {
        newRow.push(t.order.totalCost ?? '0.00')
      } else {
        newRow.push(t?.order?.currentDeposit ?? t?.order?.totalCost ?? '0.00')
        newRow.push(t?.order?.pendingToPay ?? 0)
      }
      newRow.push((t?.order?.promoterFirstName ?? '') + ' ' + (t?.order?.promoterLastName ?? ''))
      newRow.push(t?.order?.promoterEmail ?? '')
      newRow.push((t?.order?.referrerFirstName ?? '') + ' ' + (t?.order?.referrerLastName ?? ''))
      newRow.push(t?.order?.referrerEmail ?? '')
      data.push(newRow)
    })
    return data
  }

  onDisableToggle = async (data, id, disabled) => {
    const { TOGGLE_ORDER_RESALE, event } = this.props
    const { loading } = this.state
    this.setState({ loading: { [id]: true } })
    await TOGGLE_ORDER_RESALE(event.id, id, { disabled })
    this.setState({ loading: { ...loading, [id]: false } })
  }

  onMarkAsPaid = async (data, id, disabled) => {
    const { MARK_ORDER_AS_PAID, FETCH_EVENT_ORDERS, event } = this.props
    const { loading } = this.state
    this.setState({ loading: { ...loading, ['authorize_' + id]: true } })
    await MARK_ORDER_AS_PAID(event.id, id, { disabled })
    await FETCH_EVENT_ORDERS(event.id)
    this.setState({ loading: { ...loading, ['authorize_' + id]: false } })
  }

  onRejectPendingOrder = async (data, id, disabled) => {
    const { REJECT_PENDING_ORDER, FETCH_EVENT_ORDERS, event } = this.props
    const { loading } = this.state
    this.setState({ loading: { ...loading, ['reject_' + id]: true } })
    await REJECT_PENDING_ORDER(event.id, id, { disabled })
    await FETCH_EVENT_ORDERS(event.id)
    this.setState({ loading: { ...loading, ['reject_' + id]: false } })
  }

  getTicketTagsColumn = tags => (
    <div>
      {tags &&
        tags.map((tag, ii) => (
          <div key={ii} className="row-ticket-tag">
            {tag}
          </div>
        ))}
    </div>
  )

  shouldDisplayTablesColumns = data =>
    data.reduce((res, row) => {
      let guestCount = parseInt(row.order.guestCount)
      if (isNaN(guestCount)) {
        guestCount = 0
      }

      return res || guestCount > 0
    }, false)

  getTableHeaderColumns = (includeTablesData, clipboard) => {
    const columns = [
      { title: '', sort: false },
      { title: 'Order ID', sort: true },
      { title: 'Date', sort: true },
      { title: 'Status', sort: true },
      { title: 'Name', sort: true },
      { title: 'Email', sort: true },
      { title: 'No. of Tickets', sort: true },
    ]

    if (this.props.event?.flagOrderPaymentMethodDisplay) {
      columns.push({ title: 'Payment Method Type', sort: true })
    }

    if (!includeTablesData) {
      columns.push({ title: 'Net Revenue', sort: true })
    } else {
      columns.push({ title: 'Current Deposit', sort: true })
      columns.push({ title: 'Pending to Pay', sort: true })
    }

    columns.push(
      { title: 'Action', sort: false },
      { title: clipboard, sort: false, className: 'column-clipboard' },
    )

    return columns
  }

  getOxxoTableHeaderColumns = event =>
    getTableColumns([
      {
        key: 'id',
        label: 'Order Id',
        isSortable: true,
      },
      {
        key: 'orderDateTime',
        label: 'Date',
        isSortable: true,
      },
      {
        key: 'orderStatus',
        label: 'Status',
        isSortable: true,
      },
      {
        key: 'fullName',
        label: 'Name',
        isSortable: true,
      },
      {
        key: 'billingEmail',
        label: 'Email',
        isSortable: true,
      },
      {
        key: 'quantity',
        label: 'No. of Tickets',
        isSortable: true,
      },
      {
        key: 'totalCost',
        label: 'Net Revenue',
        isSortable: true,
        normalizer: value =>
          currencyNormalizerCreator(getCurrencySymbol(event))(
            createFixedFloatNormalizer(2)(parseFloat(value)),
          ),
        disableNormalizerOnCopy: true,
      },
    ])

  getTableData = (datatable, rows_filtered, sort) => {
    const { eventRole, event, addOns, user, configs } = this.props
    const { loading } = this.state
    const tableData = []
    const detailsData = []

    const includeTablesData = this.shouldDisplayTablesColumns(rows_filtered) > 0

    const clipboard_text = this.getClipboardText(rows_filtered, includeTablesData)
    const clipboard = datatable.getClipboardColumn(datatable, clipboard_text)

    const headerColumns = this.getTableHeaderColumns(includeTablesData, clipboard)
    const tableColumns = this.getOxxoTableHeaderColumns(event)

    const content_header = datatable.getHeaderRow(datatable, headerColumns, sort)

    const self = this
    let number = 0
    const content_table = _map(rows_filtered, (t, index) => {
      if (!this.defaultTicketTypeIDs[t.id] && t.tickets && t.tickets.length) {
        this.defaultTicketTypeIDs[t.id] = t.tickets[0].ticketTypeID
      }

      let total
      let debt
      if (!includeTablesData) {
        total = parseFloat(t.order.totalCost)
      } else {
        total = parseFloat(t.order.currentDeposit)
        total = isNaN(total) ? parseFloat(t.order.totalCost) : total

        debt = parseFloat(t.order.pendingToPay)
        debt = isNaN(debt) ? 0 : debt
      }

      const currency = getCurrencySymbol(event, t.order.currency ?? null)
      const showIssueGuestAddOnButton = _get(configs, 'appearance.showIssueGuestAddOnButton')
      const detailRowContent = orderDetailRow({
        t,
        event,
        index,
        includeTablesData,
        currency,
        total,
        debt,
        openTicketEditModal: this.openTicketEditModal,
        openSeatEditModal: this.openSeatEditModal,
        setTicketTypesBulkUpdateModalState: this.setTicketTypesBulkUpdateModalState,
        setIssueAddOnModalState: this.setIssueAddOnModalState,
        addOns,
        user,
        eventRole,
        showIssueGuestAddOnButton,
      })

      tableData.push({
        ...t.order,
        fullName: t.order.billingFirstName + ' ' + t.order.billingLastName,
        orderStatus: t.order.status,
        quantity: t.tickets?.length ?? 0,
      })

      detailsData.push({
        id: t.id,
        type: 'detailRow',
        component: detailRowContent,
      })

      let content_row = null
      if (!t.isDetailRow) {
        // normal row
        const isOxxoOrder = _get(t, 'order.isOxxoPayment') === '1' ? true : false
        const isPendingOrder = t.order.status === 'Pending'
        const resaleDisabled = _get(t, 'order.disableResale', false)
        const toggleButtonLoading = loading[t.id]
        const markAsPaidButtonLoading = loading[t.id]
        const authorizeOrderButtonLoading = loading['authorize_' + t.id]
        const rejectOrderButtonLoading = loading['reject_' + t.id]
        const isToggleButtonsVisible = event.flagResaleEnabled && !isOxxoOrder && !isPendingOrder
        const disputeStatus = _get(t, 'order.disputeStatus')
        const isDisputed = disputeStatus && disputeStatus !== 'won'
        const canIssueRefunds = canIssueRefundsOnEvent(event)
        const canUseRefundButton = canSeeRefundButton(t.order, event, user, eventRole, t.tickets)
        content_row = (
          <tr
            key={index}
            className={
              isDisputed &&
              'ticket-orange ' +
              (t.isExpanded
                ? ' tr-expanded-row'
                : number++ % 2 === 0
                  ? 'table-stripe-row1'
                  : 'table-stripe-row2')
            }
          >
            <td
              aria-hidden={true}
              className="toggleExpand"
              onClick={() => this.onClickExpandDetail(datatable, t)}
              data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${index}-expanded`}
            >
              <div className={t.isExpanded ? 'expandIcon expanded' : 'expandIcon'}>
                <i className={t.isExpanded ? 'fa fa-minus-square-o' : 'fa fa-plus-square-o'} />
              </div>
            </td>
            <td data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${index}-id`}>{t.id}</td>
            <td data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${index}-orderDateTime`} className="nowrap-col">
              {moment(t.order.orderDateTime, 'YYYY-MM-DD HH:mm:ss').format('D MMM YYYY hh:mm a')}
            </td>
            <td data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${index}-status`}>{toPascalCase(t.order.status)}</td>
            <td data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${index}-billingName`}>
              {t.order.billingFirstName} {t.order.billingLastName}
            </td>
            <td data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${index}-billingEmail`}>{t.order.billingEmail}</td>
            <td data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${index}-ticketQuantity`}>
              {(t?.tickets || []).filter(({ status }) => status !== 'cancelled' && status !== 'refunded')
                ?.length ??
                t?.gift?.ticketQuantity ??
                0}
            </td>
            {event?.flagOrderPaymentMethodDisplay && (
              <td data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${index}-ticketQuantity`}>
                <div style={{ display: 'inline-flex', gap: 10, alignItems: 'center' }}>
                  <span style={{ width: '30px', display: 'inline-block' }}>
                    {getPaymentMethodIcon(t?.order?.paymentMethodDisplayType || '')}
                  </span>
                  <span>{_startCase(t?.order?.paymentMethodDisplayType || '')}</span>
                </div>
              </td>
            )}
            <td data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${index}-netRevenue`}>
              {currency}
              {total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </td>
            {includeTablesData && (
              <td data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${index}-debt`}>
                {currency}
                {debt.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </td>
            )}
            <td className="tdAction" data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${index}-actions`}>
              <div
                aria-hidden={true}
                className="btnAction"
                onClick={self.onClickResend.bind(self, t.id, t.order.billingEmail)}
              >
                <img
                  alt="nodata"
                  className="default-icosize"
                  src={asset('/resources/images/resend-ico.svg')}
                />
                <span className="inline pl-5">Resend</span>
              </div>
              {total === 0 && !(ROLES.PARTIAL_SUPPORT === eventRole) && t.order.status_id != ORDER_STATUS_CANCELLED && (
                <div aria-hidden={true} className="btnAction" onClick={self.onClickCancel.bind(self, t.id)}>
                  <img
                    alt="nodata"
                    className="default-icosize"
                    src={asset('/resources/images/cross-ico.svg')}
                  />
                  <span className="inline pl-5">Cancel</span>
                </div>
              )}
              {isToggleButtonsVisible && (
                <>
                  {!resaleDisabled ? (
                    toggleButtonLoading ? (
                      <div className="btnAction">
                        <i className="fa fa-spin fa-spinner" aria-hidden="true" />
                      </div>
                    ) : (
                      <div
                        aria-hidden={true}
                        className="btnAction"
                        onClick={() => this.onDisableToggle(t, t.id, true)}
                      >
                        <i className="fa fa-ban" aria-hidden="true" />
                        <span className="inline pl-5 nowrap-col">Block Resale</span>
                      </div>
                    )
                  ) : toggleButtonLoading ? (
                    <div className="btnAction">
                      <i className="fa fa-spin fa-spinner" aria-hidden="true" />
                    </div>
                  ) : (
                    <div
                      aria-hidden={true}
                      className="btnAction"
                      onClick={() => this.onDisableToggle(t, t.id, false)}
                    >
                      <i className="fa fa-fw fa-check" aria-hidden="true" />
                      <span className="inline pl-5">Unblock Resale</span>
                    </div>
                  )}
                </>
              )}
              {isPendingOrder &&
                (authorizeOrderButtonLoading ? (
                  <div className="btnAction">
                    <i className="fa fa-spin fa-spinner" aria-hidden="true" />
                  </div>
                ) : (
                  <div
                    aria-hidden={true}
                    className="btnAction"
                    onClick={() => this.onMarkAsPaid(t, t.id, true)}
                  >
                    <i className="fa fa-check" aria-hidden="true" />
                    <span className="inline pl-5">Approve</span>
                  </div>
                ))}
              {isPendingOrder &&
                (rejectOrderButtonLoading ? (
                  <div className="btnAction">
                    <i className="fa fa-spin fa-spinner" aria-hidden="true" />
                  </div>
                ) : (
                  <div
                    aria-hidden={true}
                    className="btnAction"
                    onClick={() => this.onRejectPendingOrder(t, t.id, true)}
                  >
                    <i className="fa fa-times" aria-hidden="true" />
                    <span className="inline pl-5">Decline</span>
                  </div>
                ))}
              {canUseRefundButton &&
                requestRefundAuthCode(t.order) &&
                conditionalOverlay(
                  loading[t.order.orderHash] ? (
                    <div className="btnAction">
                      <i className="fa fa-spin fa-spinner" aria-hidden="true" />
                    </div>
                  ) : (
                    <div
                      aria-hidden={true}
                      className="btnAction"
                      onClick={canIssueRefunds ? this.onClickRefundConfirm.bind(this, t.order) : undefined}
                    >
                      <i className="fa fa-undo" aria-hidden="true" />
                      <span className="inline pl-5">Refund</span>
                    </div>
                  ),
                  {
                    text: <Tooltip>{this.getRefundHelperMessage(event)}</Tooltip>,
                    id: `refundTooltip-${t.order.orderHash}`,
                  },
                  !canIssueRefunds,
                )}
              {canUseRefundButton &&
                confirmRefundAuthCode(t.order) &&
                conditionalOverlay(
                  loading[t.order.orderHash] ? (
                    <div className="btnAction">
                      <i className="fa fa-spin fa-spinner" aria-hidden="true" />
                    </div>
                  ) : (
                    <div
                      aria-hidden={true}
                      className="btnAction"
                      onClick={() => {
                        if (canIssueRefunds) {
                          this.setState({
                            showRefundCode: true,
                            refundOrderHash: t.order.orderHash,
                            refundOrderId: t.order.id, // Add the order ID here
                            refundTicketId: t.id,
                            refunding: false,
                            refunded: false,
                            refundError: null,
                            authCode: '',
                          })
                        }
                      }}
                    >
                      <i className="fa fa-key" aria-hidden="true" />
                      <span className="inline pl-5">Code</span>
                    </div>
                  ),
                  {
                    text: <Tooltip>{this.getRefundHelperMessage(event)}</Tooltip>,
                    id: `refundTooltip-${t.order.orderHash}`,
                  },
                  !canIssueRefunds,
                )}
            </td>
            <td data-e2e-test-id={`${TABLE_E2E_TEST_ID}-${index}-clipboard`} />
          </tr>
        )
      } else {
        content_row = (
          <tr
            className="tr-detail-row"
            key={index}
            name={`scroll-to-row-${t.id}`}
            ref={ref => {
              if (ref) {
                scroller.scrollTo(`scroll-to-row-${t.id}`, {
                  duration: 800,
                  delay: 0,
                  smooth: 'easeInOutQuart',
                  offset: -140,
                })
              }
            }}
          >
            <td colSpan={12} className={'colspan-customer'}>
              {detailRowContent}
            </td>
          </tr>
        )
      }
      return content_row
    })

    return rows_filtered.length !== 0 ? (
      this.state.order_status === PENDING_OXXO_ORDER ? (
        <SortableTable
          parentTableClass="table"
          tableColumns={tableColumns}
          data={tableData}
          enableCopyTable={true}
          enableSort={true}
          detailsRows={detailsData}
          actionsLabel="Action"
          dataForCopy={tableData}
          rowTableClass="oxxoTableRow"
          actions={[
            {
              label: () => <span className="inline pl-5">Resend</span>,
              className: 'oxxoBtnAction',
              icon: (
                <img
                  alt="nodata"
                  className="default-icosize"
                  src={asset('/resources/images/resend-ico.svg')}
                />
              ),
              onClick: data => this.onClickResend(data.id, data.billingEmail),
            },
          ]}
        />
      ) : (
        <table className="table" data-e2e-test-id={TABLE_E2E_TEST_ID}>
          <thead>{content_header}</thead>
          <tbody>{content_table}</tbody>
        </table>
      )
    ) : (
      <EmptyBar />
    )
  }

  getClipboardText = (rows_filtered, includeTablesData) => {
    let ret = ''
    if (!includeTablesData) {
      ret +=
        'Order ID' +
        '\t' +
        'Date' +
        '\t' +
        'Status' +
        '\t' +
        'Name' +
        '\t' +
        'Email' +
        '\t' +
        'No. of Tickets' +
        '\t' +
        'Payment Method Type' +
        '\t' +
        'Currency' +
        '\t' +
        'Net Revenue' +
        '\n'
    } else {
      ret +=
        'Order ID' +
        '\t' +
        'Date' +
        '\t' +
        'Status' +
        '\t' +
        'Name' +
        '\t' +
        'Email' +
        '\t' +
        'No. of Tickets' +
        '\t' +
        'Payment Method Type' +
        '\t' +
        'Currency' +
        '\t' +
        'Current Deposit' +
        '\t' +
        'Pending to Pay' +
        '\n'
    }
    _map(rows_filtered, t => {
      if (!includeTablesData) {
        ret +=
          t.id +
          '\t' +
          moment(t.order.orderDateTime, 'YYYY-MM-DD HH:mm:ss').format('D MMM YYYY hh:mm a') +
          '\t' +
          toPascalCase(t.order.status) +
          '\t' +
          (t.order.billingFirstName + ' ' + t.order.billingLastName) +
          '\t' +
          t.order.billingEmail +
          '\t' +
          String(
            (t?.tickets || []).filter(({ status }) => status !== 'cancelled' && status !== 'refunded')
              ?.length ??
            t?.gift?.ticketQuantity ??
            0,
          ) +
          '\t' +
          String(t?.order?.paymentMethodDisplayType || '') +
          '\t' +
          String(t?.order?.currency ?? '') +
          '\t' +
          parseFloat(t.order.totalCost ?? '0.00').toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) +
          '\n'
      } else {
        ret +=
          t.id +
          '\t' +
          moment(t.order.orderDateTime, 'YYYY-MM-DD HH:mm:ss').format('D MMM YYYY hh:mm a') +
          '\t' +
          toPascalCase(t.order.status) +
          '\t' +
          (t.order.billingFirstName + ' ' + t.order.billingLastName) +
          '\t' +
          t.order.billingEmail +
          '\t' +
          String(
            (t?.tickets || []).filter(({ status }) => status !== 'cancelled' && status !== 'refunded')
              ?.length ??
            t?.gift?.ticketQuantity ??
            0,
          ) +
          '\t' +
          String(t?.order?.paymentMethodDisplayType || '') +
          '\t' +
          String(t?.order?.currency ?? '') +
          '\t' +
          parseFloat(t?.order?.currentDeposit ?? t?.order?.totalCost ?? '0.00').toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) +
          '\t' +
          String(t?.order?.pendingToPay ?? 0) +
          '\n'
      }
    })
    return ret
  }

  onClickExportTickets = (csvData, csvFileName) => {
    DOWNLOAD_CSV(csvData, csvFileName)
  }

  handleResend = () => {
    const { RESEND_ORDER, event } = this.props
    const { orderID, resendEmail } = this.state

    return Promise.resolve(RESEND_ORDER(event.id, { orderID, resendEmail }))
      .catch(err => {
        Messenger().post({
          type: 'error',
          message: err,
          hideAfter: 5,
          showCloseButton: true,
        })
        this.setState({ showResend: false })
        return Promise.reject(_result(err, 'toFieldErrors', err))
      })
      .then(v => {
        Messenger().post({
          type: 'success',
          message: 'Successfully Sent',
          hideAfter: 10,
          showCloseButton: true,
        })
        this.setState({ showResend: false })
        return v
      })
  }

  handleCancel = () => {
    const { CANCEL_ORDER, event } = this.props
    const { orderID } = this.state

    this.setState({
      cancelling: true,
    })

    return Promise.resolve(CANCEL_ORDER(event.id, { orderID }))
      .catch(err => {
        Messenger().post({
          type: 'error',
          message: err,
          hideAfter: 5,
          showCloseButton: true,
        })
        this.setState({
          showCancel: false,
          cancelled: false,
          cancelling: false,
        })
        return Promise.reject(_result(err, 'toFieldErrors', err))
      })
      .then(v => {
        this.setState({
          showCancel: true,
          cancelled: true,
          cancelling: false,
          cancelMessage: 'The order has been successfully cancelled',
        })
        return v
      })
  }

  onClickResend = (orderID, email) => {
    this.setState({ showResend: true, resendEmail: email, orderID })
  }

  onClickCancel = orderID => {
    this.setState({
      showCancel: true,
      orderID,
      cancelMessage: 'Do you really want to cancel the order?',
    })
  }

  closeResendDialog = () => {
    this.setState({ showResend: false })
  }

  closeCancelDialog = () => {
    this.setState({
      showCancel: false,
      cancelled: false,
    })
  }

  onResendEmailChanged = e => {
    this.setState({ resendEmail: e.target.value })
  }

  onFiltersChange = filters => {
    this.setState({ filters }, () => {
      this.updateUrlWithFilters({ filters })
    })
  }

  onDateFiltersChange = dateFilterInfo => {
    this.setState({ dateFilterInfo }, () => {
      this.updateUrlWithFilters({ dateFilterInfo })
    })
  }

  onClickExpandDetail = (datatable, order) => {
    datatable.onClickDetail(order.id)
    this.setState({
      expandedID: order.isExpanded ? order.id : null,
    })
  }

  isEmptyChecker = data => {
    const { filters, dateFilterInfo, filter_compOrder } = data
    return (
      _isEmpty(filters) &&
      !filter_compOrder &&
      !_get(dateFilterInfo, 'range.start') &&
      !_get(dateFilterInfo, 'range.end')
    )
  }

  onSelectFilter = template => {
    let { value } = template
    try {
      value = JSON.parse(value)
      const { filters, filter_compOrder, dateFilterInfo } = value

      // Update state with all filter values at once
      const stateUpdate = {}
      if (filters !== undefined) stateUpdate.filters = filters
      if (filter_compOrder !== undefined) stateUpdate.filter_compOrder = filter_compOrder
      if (dateFilterInfo !== undefined) stateUpdate.dateFilterInfo = dateFilterInfo

      this.setState(stateUpdate, () => {
        this.updateUrlWithFilters(stateUpdate)
      })
    } catch (e) { }
  }

  onSaveFilter = () => {
    this.setState(s => ({ filterUpdateVersion: s.filterUpdateVersion + 1 }))
  }

  isFilterCardClosed = () => {
    const { filters, filter_compOrder, dateFilterInfo, order_status } = this.state

    // Keep card open if any filters are active
    const hasActiveFilters =
      (filters && filters.length > 0) ||
      filter_compOrder ||
      (dateFilterInfo?.range?.start || dateFilterInfo?.range?.end) ||
      (order_status && order_status !== ORDER_STATUS_ALL)

    return !hasActiveFilters
  }

  handleIssueAddOn = (collectedAddOns = []) => {
    const { event } = this.props
    const { ticketHash } = this.state

    return issueGuestAddOn(event.id, { ticketHash, addOns: collectedAddOns }).then(res => {
      this.setIssueAddOnModalState(false)
      showSuccessMessage(res.message)
      return res
    })
  }

  onClickRefund = async () => {
    const { REQUEST_REFUND_ORDER_AUTH_CODE, FETCH_EVENT_ORDERS, event } = this.props
    const { refundOrderHash, loading } = this.state

    this.setState({
      refunded: false,
      refunding: true,
      refundSuccessMessage: '',
      refundErrorMessage: '',
      loading: { ...loading, [refundOrderHash]: true },
    })

    try {
      await REQUEST_REFUND_ORDER_AUTH_CODE(refundOrderHash)

      this.setState({
        refundSuccessMessage:
          'An authorization code has been created successfully and sent to your email address',
        showRefund: false,
        showRefundCode: true,
      })

      // No toast message since we're showing it in the modal
      await FETCH_EVENT_ORDERS(event.id)
      if (this.ordersTable) {
        this.ordersTable.manualRefresh()
      }
    } catch (err) {
      // No toast error since we're showing it in the modal
      this.setState({
        refundErrorMessage:
          'Error requesting authorization code: ' +
          (err.response?.data?.message || err.message || 'Unknown error'),
      })
    } finally {
      this.setState({
        refunding: false,
        loading: { ...loading, [refundOrderHash]: false },
      })
    }
  }

  onClickRefundCode = async () => {
    const { REFUND_ORDER, FETCH_EVENT_ORDERS, event } = this.props
    const { refundOrderHash, loading, authCode, refundOrderId } = this.state

    if (!refundOrderHash) {
      return
    }

    this.setState({
      refunded: false,
      refunding: true,
      refundCodeSuccessMessage: '',
      refundCodeErrorMessage: '',
      loading: { ...loading, [refundOrderHash]: true },
    })

    try {
      await REFUND_ORDER(refundOrderHash, authCode)

      this.setState({
        refunded: true,
        refundCodeSuccessMessage: `Order ${refundOrderId} refunded successfully`,
      })

      // No toast message since we're showing it in the modal
      await FETCH_EVENT_ORDERS(event.id)
      if (this.ordersTable) {
        this.ordersTable.manualRefresh()
      }
    } catch (err) {
      // No toast error since we're showing it in the modal
      this.setState({
        refundCodeErrorMessage:
          'Error refunding order: ' + (err.response?.data?.message || err.message || 'Unknown error'),
      })
    } finally {
      this.setState({
        refunding: false,
        loading: { ...loading, [refundOrderHash]: false },
      })
    }
  }

  onClickRefundConfirm = order => {
    this.setState({
      showRefund: true,
      refundOrderHash: order.orderHash,
      refundOrderId: order.id, // Save the order ID to state
      refundMessage: `You are refunding ${order.currency}${order.totalCost} for Order #${order.id}`,
      refundHelperMessage:
        'Please note. All refunds are face value and exclude service fees which are <a href="https://www.ticketfairy.com/refunds" target="_blank" style="color:rgb(112, 181, 255); text-decoration: underline;">non-refundable</a>. If you would like to process a full refund instead, please email <a href="mailto:clientsupport@ticketfairy.com" style="color:rgb(112, 181, 255); text-decoration: underline;">clientsupport@ticketfairy.com</a>.',
      refunded: false,
      authCode: '',
    })
  }

  onClickResendCode = async () => {
    const { RESEND_CODE, FETCH_EVENT_ORDERS, event } = this.props
    const { refundOrderHash, loading } = this.state

    this.setState({
      refunded: false,
      resendingCode: true,
      refundCodeSuccessMessage: '',
      refundCodeErrorMessage: '',
      loading: { ...loading, [refundOrderHash]: true },
    })

    try {
      await RESEND_CODE(refundOrderHash)

      this.setState({
        resendingCode: false,
        refundCodeSuccessMessage: 'The authorization code has been sent to your email address',
      })

      // No toast message since we're showing it in the modal
      await FETCH_EVENT_ORDERS(event.id)

      if (this.ordersTable) {
        this.ordersTable.manualRefresh()
      }
    } catch (err) {
      // No toast error since we're showing it in the modal
      this.setState({
        refundCodeErrorMessage:
          'Error resending code: ' + (err.response?.data?.message || err.message || 'Unknown error'),
      })
    } finally {
      this.setState({
        resendingCode: false,
        showRefundCode: false,
        loading: { ...loading, [refundOrderHash]: false },
      })
    }
  }

  onClickRevokeCode = async () => {
    const { REVOKE_CODE, FETCH_EVENT_ORDERS, event } = this.props
    const { refundOrderHash, loading } = this.state

    this.setState({
      refunded: false,
      revokingCode: true,
      refundCodeSuccessMessage: '',
      refundCodeErrorMessage: '',
      loading: { ...loading, [refundOrderHash]: true },
    })

    try {
      await REVOKE_CODE(refundOrderHash)

      this.setState({
        revokingCode: false,
        refundCodeSuccessMessage: 'The authorization code has been revoked',
      })

      // No toast message since we're showing it in the modal
      await FETCH_EVENT_ORDERS(event.id)

      if (this.ordersTable) {
        this.ordersTable.manualRefresh()
      }
    } catch (err) {
      // No toast error since we're showing it in the modal
      this.setState({
        refundCodeErrorMessage:
          'Error revoking code: ' + (err.response?.data?.message || err.message || 'Unknown error'),
      })
    } finally {
      this.setState({
        revokingCode: false,
        showRefundCode: false,
        loading: { ...loading, [refundOrderHash]: false },
      })
    }
  }

  getRefundHelperMessage = event => {
    if (event?.flagFundsRemitted) {
      // eslint-disable-next-line max-len
      return 'Ticket sales revenue has been released to your bank account. Please refund the customer directly through an alternative method.'
    }
    if (event?.flagPaidInAdvance) {
      // eslint-disable-next-line max-len
      return 'A portion of the ticket sales revenue has been released to your account. Please email clientsupport@ticketfairy.com in order to process this refund.'
    }
    if (event?.flagWithholdPayout) {
      return 'Refunds are currently disabled for this event. Please email clientsupport@ticketfairy.com to process this refund'
    }
  }

  closeRefundDialog = () => {
    this.setState({
      showRefund: false,
      showRefundCode: false,
      refunded: false,
      refundSuccessMessage: '',
      refundErrorMessage: '',
      refundCodeSuccessMessage: '',
      refundCodeErrorMessage: '',
      authCode: '',
      // Note: We're intentionally NOT clearing refundOrderId here to preserve it
    })
  }

  closeRefundCodeDialog = () => {
    this.setState({
      showRefundCode: false,
      refundCodeSuccessMessage: '',
      refundCodeErrorMessage: '',
      authCode: '',
      // Note: We're intentionally NOT clearing refundOrderId here to preserve it
    })
  }

  render() {
    const {
      order_status,
      filter_types,
      filter_addons,
      filter_discountcodes,
      filter_payment_types,
      filter_compOrder,
      filterReferrers,
      filter_promotions,
      filter_tags,
      filters,
      dateFilterInfo,
      filterUpdateVersion,
    } = this.state
    const {
      showResend,
      resendEmail,
      showCancel,
      cancelMessage,
      cancelled,
      cancelling,
      ticketEditModalShow,
      seatEditModalShow,
      isTicketTypesBulkUpdateModalOpen,
      isIssueAddOnModalOpen,
      ticketEdited,
      seatsIoConfigData,
      isLoadingSeatsIoConfigData,
      isUpdatingSeats,
      changeSeatData,
      selectedSeatsIoEvent,
    } = this.state
    const { isTicketsTypeUpdating, ordersState, event, eventRole, tickets, configs, addOns, user } =
      this.props
    const isTtfTeam = ROLES.is_tf_support_admin_or_client_admin(user.tfRole)
    const isTfDeveloper = user?.tfRole === ROLES.TF_DEVELOPER

    let showSeatMapPicker = false
    let selectedTicketSeatsIoConfig = ticketEdited?.seatMapId
      ? seatsIoConfigData?.season_events?.find(event => event.id === ticketEdited.seatMapId)
      : null

    // Pre-set the selected seats io map from the season individual seats io map if it belongs to a particular seats io map
    if (ticketEdited?.seatMapId) {
      selectedTicketSeatsIoConfig =
        seatsIoConfigData?.season_events?.find(event => event.id === ticketEdited.seatMapId) ?? null
    }

    // If we didn't set a map but the ticket still has a seat map id, then we need to set the season or main seats io map
    if (ticketEdited?.seatMapId && !selectedTicketSeatsIoConfig && seatsIoConfigData?.type === 'season') {
      selectedTicketSeatsIoConfig = seatsIoConfigData
    }

    // If at this point we haven't pre-set a seats.io map, we select one from the map picker.
    // This selection will indicate that the map picker must render on the UI.
    //
    // If this logic still does not set a seats.io map, we fall back to using the main seats.io map.
    // The picker will display this default selection, allowing the customer to change it if necessary.
    if (!selectedTicketSeatsIoConfig && seatsIoConfigData?.type === 'season') {
      selectedTicketSeatsIoConfig =
        seatsIoConfigData?.season_events?.find(event => event.id === selectedSeatsIoEvent) ?? null
      showSeatMapPicker = true
    }

    const showSoldOrders = _get(configs, 'appearance.showSoldOrders', true)
    const showPendingPaymentPlanOrders = _get(configs, 'appearance.showPendingPaymentPlanOrders', true)

    const [noGroupedTickets, groupedTickets] = ticketTypesSorting(tickets)
    const tabs = [
      ORDER_STATUS_ALL,
      ORDER_STATUS_PAID,
      ORDER_STATUS_SOLD,
      ORDER_STATUS_REFUNDED,
      ORDER_STATUS_PENDING,
      ORDER_STATUS_CANCELLED,
    ].filter(tab => !(tab === ORDER_STATUS_SOLD && !showSoldOrders))

    if (showPendingPaymentPlanOrders) {
      tabs.push(PENDING_PAYMENT_PLAN)
    }

    if (event.flagIsOxxoPaymentEnabled) {
      tabs.push(PENDING_OXXO_ORDER)
    }

    if (event.idVerificationRequired) {
      tabs.push(NEED_ID_VERIFICATION)
    }

    const tab_header = _map(tabs, s => {
      let title = ''
      switch (s) {
        case ORDER_STATUS_ALL:
          title = 'All Orders'
          break
        case ORDER_STATUS_PAID:
          title = 'Paid Orders'
          break
        case ORDER_STATUS_SOLD:
          title = 'Sold Orders'
          break
        case ORDER_STATUS_REFUNDED:
          title = 'Refunded Orders'
          break
        case ORDER_STATUS_PENDING:
          title = 'Pending Orders'
          break
        case ORDER_STATUS_CANCELLED:
          title = 'Cancelled Orders'
          break
        case PENDING_PAYMENT_PLAN:
          title = 'Pending Payment Plan Orders'
          break
        case PENDING_OXXO_ORDER:
          title = 'Pending OXXO Orders'
          break
        case NEED_ID_VERIFICATION:
          title = 'Need ID Verification'
          break
        default:
          break
      }
      return (
        <div
          aria-hidden={true}
          key={s}
          className={'tab-title' + (s === order_status ? ' selected' : '')}
          onClick={() => this.onClickTab(s)}
        >
          {title}
        </div>
      )
    })
    const select_filter_types = []
    _map(filter_types, (e, i) => {
      const matchedTicketType = (tickets || []).find(t => (t.displayName || t.name || t.ticketType) === e)
      select_filter_types.push({ value: e, label: e, itemId: matchedTicketType?.id || null })
    })
    const select_filter_addons = []
    _map(filter_addons, (e, i) => {
      const matchedAddOn = (addOns || []).find(a => a.name === e)
      select_filter_addons.push({ value: e, label: e, itemId: matchedAddOn?.id || null })
    })
    const select_filter_discountcodes = []
    _map(filter_discountcodes, (e, i) => {
      select_filter_discountcodes.push({ value: e, label: _startCase(e) })
    })
    const selected_filter_promotions = []
    _map(filter_promotions, (e, i) => {
      selected_filter_promotions.push({ value: e, label: e })
    })
    const select_filter_payment_types = []
    _map(filter_payment_types, (e, i) => {
      select_filter_payment_types.push({ value: _startCase(e), label: _startCase(e) })
    })
    const select_filter_tags = []
    _map(filter_tags, (e, i) => {
      select_filter_tags.push({ value: e, label: e })
    })

    // Build export URLs
    const exportURLAll = `${ENV.API_BASE}/api/event/${event.id}/tickets/export/`
    const exportAddonURL = `${ENV.API_BASE}/api/event/${event.id}/add-on/export/`
    const hasFilters = filters && filters.length > 0
    let exportURLFiltered = null

    if (hasFilters) {
      // Backfill missing itemId for saved filters using current options
      const ticketTypeIdByName = (select_filter_types || []).reduce((acc, opt) => {
        acc[opt.value] = opt.itemId || null
        return acc
      }, {})
      const addOnIdByName = (select_filter_addons || []).reduce((acc, opt) => {
        acc[opt.value] = opt.itemId || null
        return acc
      }, {})
      const referrerIdByName = (filterReferrers || []).reduce((acc, opt) => {
        acc[opt.value] = opt.id || null
        return acc
      }, {})

      const filtersWithIds = (filters || []).map(f => {
        if (f.itemId) return f
        if (f.type === 'ticketType') return { ...f, itemId: ticketTypeIdByName[f.value] || null }
        if (f.type === 'addOn') return { ...f, itemId: addOnIdByName[f.value] || null }
        if (f.type === 'referrers') return { ...f, itemId: referrerIdByName[f.value] || null }
        return f
      })

      const filtersParam = encodeURIComponent(JSON.stringify(filtersWithIds))
      exportURLFiltered = `${exportURLAll}?filters=${filtersParam}`
    }

    let tabData = tab_header
    if (!isMobileDevice()) {
      tabData = (
        <div style={{ position: 'relative', width: `calc(100% - 130px)` }}>
          {' '}
          <PerfectScrollbar>{tab_header}</PerfectScrollbar>
        </div>
      )
    }

    const ticketEditedHasSeat = !!ticketEdited?.seatName
    return (
      <div className="event-order">
        {!ROLES.is_partial_support(eventRole) && (
          <div className="btn-toolbar export-tickets">
            {(ROLES.is_tf_support_admin_or_client_admin(user?.tfRole) ||
              user?.tfRole === ROLES.TF_DEVELOPER) &&
              (event?.flagBulkTicketTypePrint ?? false) && (
                <TicketTypeBulkPrint ticketTypes={tickets} event={event} />
              )}
            {/*csvData && <Button className="btn-primary" onClick=
            {this.onClickExportTickets.bind(this, csvData, csvFileName)}>Export Tickets</Button>*/}
            {(event?.flagExportAddons ?? false) && (
              <a className="btn btn-primary btn-shadow" href={exportAddonURL}>
                {' '}
                <img alt="nodata" src={asset('/resources/images/excel-ico.svg')} />
                Export Add-ons
              </a>
            )}
            <a className="btn btn-primary btn-shadow" href={exportURLAll}>
              {' '}
              <img alt="nodata" src={asset('/resources/images/excel-ico.svg')} />
              Export All Tickets to CSV
            </a>
            {/*
						<Button className="btn-default" onClick={() => this.refreshTable()}>Refresh</Button>*/}
          </div>
        )}
        <Modal
          className="modal-dialog modal-trans"
          style={modalStyle}
          isOpen={showResend}
          contentLabel="Modal"
          onRequestClose={() => this.closeResendDialog()}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div>
                <div className="modal-header">
                  <p className="h4 text-compact">Resend Order</p>
                </div>
                <div className="modal-body">
                  <Field
                    ref="resend_email"
                    id="resend_email"
                    value={resendEmail}
                    label="Email Address"
                    size="large"
                    onChange={evt => this.onResendEmailChanged(evt)}
                  />
                </div>
                <div className="modal-footer">
                  <div className="btn-toolbar btn-toolbar-right">
                    <Button
                      className="btn btn-success btn-shadow"
                      type="button"
                      onClick={() => this.handleResend()}
                    >
                      Resend
                    </Button>
                    <Button
                      className="btn btn-cancel btn-shadow"
                      type="button"
                      onClick={() => this.closeResendDialog()}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          className="modal-dialog modal-trans"
          style={modalStyle}
          isOpen={showCancel}
          contentLabel="Modal"
          onRequestClose={() => this.closeCancelDialog()}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div>
                <div className="modal-header">
                  <p className="h4 text-compact">Cancel Order</p>
                </div>
                <div className="modal-body">
                  <p>{cancelMessage}</p>
                </div>
                <div className="modal-footer">
                  <div className="btn-toolbar btn-toolbar-right">
                    {!cancelled && (
                      <Button
                        className="btn btn-danger btn-shadow"
                        type="button"
                        disabled={cancelling}
                        onClick={() => this.handleCancel()}
                      >
                        Confirm Cancellation
                        {cancelling && <i className="fa fa-circle-o-notch fa-spin" />}
                      </Button>
                    )}
                    {cancelled && (
                      <Button
                        className="btn btn-primary btn-shadow"
                        type="button"
                        onClick={() => this.closeCancelDialog()}
                      >
                        OK
                      </Button>
                    )}
                    {!cancelled && (
                      <Button
                        className="btn btn-default btn-shadow"
                        type="button"
                        disabled={cancelling}
                        onClick={() => this.closeCancelDialog()}
                      >
                        Cancel
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          className="modal-dialog modal-trans"
          style={modalStyle}
          isOpen={ticketEditModalShow}
          contentLabel="Modal"
          onRequestClose={() => this.closeTicketEditModal()}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog modal-event-order-ticket">
            <div className="modal-content">
              <div className="modal-header">Edit Ticket</div>
              <div className="modal-body">
                <EventOrderTicketForm
                  onSubmit={form => this.handleTicketSave(form)}
                  onCancel={() => this.closeTicketEditModal()}
                  submitLabel="Save"
                  initialValues={ticketEdited}
                  event={event}
                  tickets={tickets}
                />
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          className="modal-dialog modal-trans seatsio-modal"
          style={modalStyle}
          isOpen={seatEditModalShow}
          ariaHideApp={false}
          contentLabel="Modal"
          onRequestClose={() => this.closeSeatEditModal()}
          closeTimeoutMS={10}
        >
          <div
            className="seatsio-modal-container"
            style={{ backgroundColor: '#292d32', justifyContent: 'center', textAlign: 'center' }}
          >
            <div className="modal-header">
              <p className="h4 text-compact">Change Seat</p>
            </div>

            <div className="seatsio-manager">
              {isLoadingSeatsIoConfigData && <InlineLoader />}
              {!isLoadingSeatsIoConfigData && (
                <SeatsioEventManager
                  ref={this.seatsIoRef}
                  secretKey={seatsIoConfigData?.workplace_secret_key ?? null}
                  event={selectedTicketSeatsIoConfig?.event_id ?? seatsIoConfigData?.event_id ?? null}
                  region={seatsIoConfigData?.region ?? null}
                  selectableObjects={ticketEditedHasSeat ? [ticketEdited.seatName] : null}
                  selectedObjects={ticketEditedHasSeat ? [ticketEdited.seatName] : null}
                  unavailableObjectsSelectable={false}
                  mode="select"
                  maxSelectedObjects={1}
                  onObjectSelected={async () => {
                    const selectedObjects = await this.seatsIoRef.current.chart.listSelectedObjects()
                    this.setState(state => ({
                      changeSeatData: {
                        ...state.changeSeatData,
                        new_seat_id: selectedObjects[0].id,
                        ticketHash: ticketEdited.ticketHash,
                        new_seat_event_id: !ticketEditedHasSeat
                          ? selectedTicketSeatsIoConfig?.event_id ?? seatsIoConfigData?.event_id ?? null
                          : null,
                      },
                    }))
                  }}
                  onObjectDeselected={() => {
                    this.setState(state => ({
                      changeSeatData: {
                        ...state.changeSeatData,
                        new_seat_id: null,
                        ticketHash: null,
                        new_seat_event_id: null,
                      },
                    }))
                  }}
                />
              )}
            </div>
            <div className="modal-footer">
              <div className="btn-toolbar">
                {seatsIoConfigData?.type === 'season' && showSeatMapPicker && !ticketEditedHasSeat && (
                  <div className="section-title-sytle">
                    <label>You&apos;re currently seeing seat statuses for seat map:</label>
                    <SeatsIoSeasonEventPicker
                      seasonData={seatsIoConfigData}
                      preselectedSeatsIoId={selectedSeatsIoEvent}
                      onEventChange={newEventId => {
                        this.setState({
                          selectedSeatsIoEvent: newEventId,
                        })
                      }}
                    />
                  </div>
                )}
                {(isTtfTeam || isTfDeveloper) && ticketEditedHasSeat && (
                  <div className="additional-checkboxes">
                    <label>Release current seats after assigning new seats?</label>
                    <div className="checkbox-switch">
                      <input
                        type="checkbox"
                        id="release_old_seat"
                        checked={changeSeatData.release_old_seat}
                        onChange={e => {
                          const { checked } = e.target
                          this.setState({
                            changeSeatData: {
                              ...changeSeatData,
                              release_old_seat: checked,
                            },
                          })
                        }}
                      />
                      <label htmlFor="release_old_seat" />
                    </div>
                  </div>
                )}
                <Button
                  type="button"
                  className="btn btn-success btn-shadow"
                  onClick={() => this.handleSeatSave()}
                  disabled={isLoadingSeatsIoConfigData || isUpdatingSeats}
                >
                  Save
                </Button>
                <Button
                  type="button"
                  className="btn btn-cancel btn-shadow"
                  onClick={() => this.closeSeatEditModal()}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          className="modal-dialog modal-trans"
          style={modalStyle}
          isOpen={isTicketTypesBulkUpdateModalOpen}
          contentLabel="Modal"
          onRequestClose={this.setTicketTypesBulkUpdateModalState(false)}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog modal-event-order-ticket">
            <div className="modal-content">
              <div className="modal-header">
                {event.flagTimeSlotsEnabled ? 'Change Time Slot' : 'Change Ticket Type'}
              </div>
              <div className="modal-body">
                {groupedTickets.length || noGroupedTickets.length ? (
                  <TicketsTypeBulkUpdate
                    defaultTicketTypeId={this.defaultTicketTypeIDs[this.state.orderID]}
                    isLoading={isTicketsTypeUpdating}
                    onSubmit={form => this.handleTicketsTypeBulkUpdate(form)}
                    onCancel={this.setTicketTypesBulkUpdateModalState(false)}
                    groupedTickets={groupedTickets}
                    noGroupedTickets={noGroupedTickets}
                  />
                ) : (
                  <LoadingBar />
                )}
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          className="modal-dialog modal-trans"
          style={modalStyle}
          isOpen={isIssueAddOnModalOpen}
          contentLabel="Modal"
          onRequestClose={() => this.setIssueAddOnModalState(false)}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog modal-event-order-ticket">
            <div className="modal-content">
              <div className="modal-header">Issue Add-On</div>
              <div className="modal-body">
                <IssueAddOnForm
                  addOns={addOns}
                  handleSubmit={this.handleIssueAddOn}
                  onCancel={() => {
                    this.setIssueAddOnModalState(false)
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          className="modal-dialog modal-trans"
          style={modalStyle}
          isOpen={this.state.showRefund}
          contentLabel="Modal"
          onRequestClose={() => this.closeRefundDialog()}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div>
                <div className="modal-header">
                  <p className="h4 text-compact">Refund Order</p>
                </div>
                <div className="modal-body">
                  {this.state.refundSuccessMessage ? (
                    <div>{this.state.refundSuccessMessage}</div>
                  ) : this.state.refundErrorMessage ? (
                    <div>{this.state.refundErrorMessage}</div>
                  ) : (
                    <>
                      <p>{this.state.refundMessage}</p>
                      <p>
                        <small
                          style={{ whiteSpace: 'pre-line' }}
                          dangerouslySetInnerHTML={{ __html: this.state.refundHelperMessage }}
                        />
                      </p>
                    </>
                  )}
                </div>
                <div className="modal-footer">
                  <div className="btn-toolbar btn-toolbar-right">
                    {!this.state.refunded && (
                      <Button
                        className="btn btn-danger btn-shadow"
                        type="button"
                        disabled={this.state.refunding}
                        onClick={() => this.onClickRefund()}
                      >
                        Get authorization code
                        {this.state.refunding && (
                          <>
                            &nbsp;
                            <i className="fa fa-circle-o-notch fa-spin" />
                          </>
                        )}
                      </Button>
                    )}
                    {this.state.refunded && (
                      <Button
                        className="btn btn-primary btn-shadow"
                        type="button"
                        onClick={() => this.closeRefundDialog()}
                      >
                        OK
                      </Button>
                    )}
                    {!this.state.refunded && (
                      <Button
                        className="btn btn-default btn-shadow"
                        type="button"
                        disabled={this.state.refunding}
                        onClick={() => this.closeRefundDialog()}
                      >
                        Cancel
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          className="modal-dialog modal-trans"
          style={modalStyle}
          isOpen={this.state.showRefundCode}
          contentLabel="Modal"
          onRequestClose={() => this.closeRefundCodeDialog()}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div>
                <div className="modal-header">
                  <p className="h4 text-compact">Refund Order #{this.state.refundOrderId}</p>
                </div>
                <div className="modal-body">
                  {this.state.refundCodeSuccessMessage ? (
                    <div>{this.state.refundCodeSuccessMessage}</div>
                  ) : (
                    <div>
                      {this.state.refundCodeErrorMessage && (
                        <div style={{ marginBottom: '10px' }}>{this.state.refundCodeErrorMessage}</div>
                      )}
                      <div className="row">
                        <div className="col-xs-6">
                          <p style={{ marginTop: '10px' }}>Enter 6-character refund authorization code:</p>
                        </div>
                        <div className="col-xs-6">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              maxLength="6"
                              placeholder="XXXXXX"
                              value={this.state.authCode || ''}
                              onChange={e => this.setState({ authCode: e.target.value })}
                              style={{
                                textAlign: 'center',
                                width: '160px',
                                display: 'inline-block',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <div className="btn-toolbar btn-toolbar-right">
                    {this.state.refundCodeSuccessMessage ? (
                      <Button
                        className="btn btn-primary btn-shadow"
                        type="button"
                        onClick={() => this.closeRefundCodeDialog()}
                      >
                        OK
                      </Button>
                    ) : (
                      <>
                        <Button
                          className="btn btn-default btn-shadow"
                          type="button"
                          disabled={this.state.resendingCode}
                          onClick={() => this.onClickResendCode()}
                        >
                          Resend
                          {this.state.resendingCode && (
                            <>
                              &nbsp;
                              <i className="fa fa-circle-o-notch fa-spin" />
                            </>
                          )}
                        </Button>
                        <Button
                          className="btn btn-default btn-shadow"
                          type="button"
                          disabled={this.state.revokingCode}
                          onClick={() => this.onClickRevokeCode()}
                        >
                          Revoke
                          {this.state.revokingCode && (
                            <>
                              &nbsp;
                              <i className="fa fa-circle-o-notch fa-spin" />
                            </>
                          )}
                        </Button>
                        <Button
                          className="btn btn-danger btn-shadow"
                          type="button"
                          disabled={
                            this.state.refunding || !this.state.authCode || this.state.authCode.length !== 6
                          }
                          onClick={() => this.onClickRefundCode()}
                        >
                          Confirm Refund
                          {this.state.refunding && (
                            <>
                              &nbsp;
                              <i className="fa fa-circle-o-notch fa-spin" />
                            </>
                          )}
                        </Button>
                        <Button
                          className="btn btn-default btn-shadow"
                          type="button"
                          disabled={this.state.refunding}
                          onClick={() => this.closeRefundCodeDialog()}
                        >
                          Cancel
                        </Button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <div className="row">
          <div className="col-xs-12 event-orders">
            {ordersState.eventId !== event.id ? (
              <LoadingBar title={"Hold tight! We're getting your event's orders..."} />
            ) : null}
            {ordersState.fullReady && !ordersState.orders.length && ordersState.eventId === event.id && (
              <EmptyBar />
            )}
            {ordersState.eventId === event.id && ordersState.orders.length > 0 && (
              <JSONDatatable
                type={TYPE_FROM_ARRAY}
                data={ordersState.orders}
                sort={{ index: 1, asc: false }}
                onDataChange={this.onDataChange}
                validateData={(data, index) => this.validateData(data, index)}
                getFilteredRows={(rows, search) => this.getFilteredRows(rows, search)}
                getSortedRows={(rows_filtered, sort) => {
                  const includeTablesData = this.shouldDisplayTablesColumns(rows_filtered) > 0
                  return this.getSortedRows(rows_filtered, sort, includeTablesData)
                }}
                getTableData={(datatable, rows_filtered, sort) =>
                  this.getTableData(datatable, rows_filtered, sort)
                }
                getCSVData={rows_filtered => {
                  const includeTablesData = this.shouldDisplayTablesColumns(rows_filtered) > 0
                  return this.getCSVData(rows_filtered, includeTablesData)
                }}
                getClipboardText={rows_filtered => {
                  const includeTablesData = this.shouldDisplayTablesColumns(rows_filtered) > 0
                  this.getClipboardText(rows_filtered, includeTablesData)
                }}
                // autoRefresh={10 * 60 * 1000}
                usePagination={true}
                loadingBarTitle={"Hold tight! We're getting your event's orders..."}
                ref={table => {
                  this.ordersTable = table
                }}
                keepExpanded={this.state.expandedID}
                search={this.state.search}
                onSearchChange={this.handleOrderSearchChange}
              >
                {/* It can give additional className to SEARCHBAR, DATATABLE, PAGINATIONBAR by specifying className="XXX" */}
                <div
                  ClassName="d"
                  ref={SEARCHBAR}
                  hasSearch
                  autoFocus
                  alwaysShowSearch
                  alwaysShowTotalCount
                  labelTotalCount="Number of Matching Orders"
                />
                <div>
                  {ordersState.eventId === event.id && !ordersState.fullReady && (
                    <p className="loading-dots">Retrieving orders</p>
                  )}
                </div>
                {!ROLES.is_partial_support(eventRole) ? (
                  <Card
                    icon={'fa-filter'}
                    title={'Filter'}
                    closed={this.isFilterCardClosed()}
                    className="filter-card"
                  >
                    <div style={{ textAlign: 'end' }}>
                      <SelectFilterTemplate
                        storagePath={`event-${event.id}-orders-filter`}
                        onSelectFilter={this.onSelectFilter}
                        updateVersion={filterUpdateVersion}
                      />
                    </div>
                    <Filters
                      filters={[
                        { label: 'Ticket Type', type: 'ticketType', options: select_filter_types },
                        { label: 'Add On', type: 'addOn', options: select_filter_addons },
                        { label: 'Promotion', type: 'promotion', options: selected_filter_promotions },
                        {
                          label: 'Discount Code',
                          type: 'discountCode',
                          options: select_filter_discountcodes,
                        },
                        event?.flagOrderPaymentMethodDisplay && {
                          label: 'Payment Method Type',
                          type: 'paymentMethodDisplayType',
                          options: select_filter_payment_types,
                        },
                        {
                          label: `Referral Link`,
                          type: 'referrers',
                          options: filterReferrers,
                        },
                        { label: 'Attendee Tag', type: 'tags', options: select_filter_tags },
                      ].filter(Boolean)}
                      onFiltersChange={filters => this.onFiltersChange(filters)}
                      value={filters}
                    >
                      {event.flagTimeSlotsEnabled && (
                        <OrderDateFilter
                          tickets={tickets}
                          timezone={event.timezone}
                          onChange={this.onDateFiltersChange}
                        />
                      )}
                      <div className="row">
                        <div className="guest-row guest-ticket-sm col-xs-6">
                          <div className="line pt-10">
                            <div className="line-cell">
                              <div className="checkbox-switch">
                                <input
                                  type="checkbox"
                                  id="filter-guest-tickets"
                                  checked={filter_compOrder}
                                  onChange={(e, value) => this.onFilterCompOrder(e, value)}
                                />
                                <label htmlFor="filter-guest-tickets" />
                              </div>
                            </div>
                            <div className="line-cell">
                              <label htmlFor="filter-guest-tickets" className="show-guest-only">
                                Only Show Guest Ticket Orders
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <br />
                        <SaveTemplate
                          data={{
                            filters,
                            dateFilterInfo,
                            filter_compOrder,
                          }}
                          isEmptyChecker={this.isEmptyChecker}
                          storagePath={`event-${event.id}-orders-filter`}
                          onSaveFilter={this.onSaveFilter}
                        />
                      </div>
                    </Filters>
                  </Card>
                ) : null}

                <div className="tab-view">
                  <div
                    className={`tab-header event-orders-tab-header  ${isMobileDevice() ? 'responsive-tab-header' : ''
                      }`}
                  >
                    <div className="tab-view-title">Show Orders:</div>
                    {tabData}
                  </div>
                </div>
                <div ref={DATATABLE} />
                <div ref={PAGINATIONBAR} hasCSVExport csvFileName={`orders_${event.id}.csv`} />
              </JSONDatatable>
            )}
          </div>
        </div>
      </div>
    )
  }
}
